import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CustomerService } from '../../../../services/customer.service';
import { AdministratorService } from '../../../../services/administrator.service';
import { SalesService } from '../../../../services/sales.service';
import { Product, RecentInteractions, SalesOrder, UpdateInventory, gridPageRequest } from '../../../../model/common/common.model';
import { UnitsOfMeasure, Warehouse } from '../../../../model/administration.model';
import { SalespersonLookupComponent } from '../../../Lookup/salesperson-lookup/salesperson-lookup.component';
import { salesPerson } from '../../../../model/masters.model';
import { TermscodeLookupComponent } from '../../../Lookup/termscode-lookup/termscode-lookup.component';
import _ from 'lodash';
import { LoaderComponent } from '../../../loader/loader.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../shared/shared.module';
import { ShipToCustomerLookupComponent } from '../../../Lookup/shiptocustomer-lookup/shiptocustomer-lookup.component';
import { BillToCustomerLookupComponent } from '../../../Lookup/billtocustomer-lookup/billtocustomer-lookup.component';
import { InventoryService } from '../../../../services/inventory.service';
import { viewproductLookupComponent } from '../../../Lookup/viewproduct-lookup/viewproduct-lookup.component';
import { CloseQuickProductLookupComponent } from '../../../Lookup/close-quick-product-lookup/close-quick-product-lookup.component';
import { UOMLookupComponent } from '../../../Lookup/uomlookup/uomlookup.component';
import { MultiProductDescriptionLookupComponent } from '../../../Lookup/multi-product-description-lookup/multi-product-description-lookup.component';
import { ListLinkedFilesLookupComponent } from '../../../Lookup/List-Linked-Files-lookup/list-linked-files.lookup.component';
import { POCommentsLookupComponent } from '../../../Lookup/pocomments-lookup/pocomments-lookup.component';
import { CloseQuickCustomerLookupComponent } from '../../../Lookup/close-quick-customer-lookup/close-quick-customer-lookup.component';
import { SpecificationLookupComponent } from '../../../Lookup/specification-lookup/specification-lookup.component';
import { PaymentReceiptService } from '../../../../services/payment-receipt.service';
import { ApplyCustomerCreditsLookupComponent } from '../../../Lookup/apply-customer-credits-lookup/apply-customer-credits-lookup.component';
import { viewproductdataLookupComponent } from '../../../Lookup/viewproductdata-lookup/viewproductdata-lookup.component';
import { getCurrentISTDate, getISTDateString, getISTDateWithCurrentTime, getISTDateWithCurrentTime2 } from '../../../../utils/date-utils';
import { catchError, concatMap, EMPTY, finalize, forkJoin, from, Observable, of, switchMap } from 'rxjs';
import { map } from 'rxjs';
import { EmailTemplateService } from '../../../../services/email-template.service';
import { formatDateDDMMYY } from '../../../../services/formatDateDDMMYY';
import { ReportCenterService } from '../../../../services/report-center.service';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';
import { TaxEngineService } from '../../../../services/tax-engine.service';
import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { discountAmountFromPercent, netFromAmountAndPercent, round2 } from '../../../../shared/discount-percent.util';
import { ProjectBomLookupComponent } from '../../../Lookup/projectbom-lookup/projectbom-lookup.component';

@Component({
  selector: 'app-create-invoice',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent],
  templateUrl: './create-invoice.component.html',
  styleUrl: './create-invoice.component.scss'
})
export class CreateInvoiceComponent {
  @ViewChild('productCodeInputRef') productCodeInputRef!: any;
  userList: any;
  deliveryDate: any | undefined;
  productId: any;
  customer: any;

  constructor(private router: Router, private messageService: MessageService, private customerService: CustomerService, private administratorService: AdministratorService,
    public dialogService: DialogService, public ref: DynamicDialogRef, private inventoryService: InventoryService, private salesService: SalesService, private el: ElementRef, private confirmationService: ConfirmationService,
    private route: ActivatedRoute, private paymentService: PaymentReceiptService, private emailTemplateService: EmailTemplateService, private reportService: ReportCenterService, private porderservice: PurchaseorderService, private taxEngine: TaxEngineService) { }

  loader: boolean = false;
  isEdit: boolean = false;
  isIGST: boolean = false;
  submitted: boolean = false;
  activeIndex: number = 0;
  selectedCustomerEmail: string | null = null;
  selectedCustomerName: string | null = null;
  isEditingQuantity: boolean = false;
  isEditingWeight: boolean = false;
  previewImage: string = "./assets/no-image.jpg";
  productCostCalculationType: string | undefined;
  QAvail: number = 0;
  isQAvailWarning: boolean = false;
  unitLabel: string = '';
  isClosedTime: boolean = false;
  outstandingReceivables: number = 0;
  companyInfo: any = {};
  emailFromSystemConfig: string = '';
  ReportPath: any;
  customerEmail: any;
  sendEmailOnInvoice: boolean = false;
  salesOrderId: number | null = null;
  isOpenStatus: boolean = false;
  invoiceStatus: string = '';
  priorPaidAmount: number = 0;
  showRCM: boolean = false;
  isGlPosted = false;
  glEntries: any[] = [];
  glTotalDebit = 0;
  glTotalCredit = 0;
  glTransactionNo = '';
  canEdit: any;


  readonly glDisplayColumns: { field: string; header: string; align?: 'right'; format?: 'amount' | 'date' }[] = [
    { field: 'accountCode', header: 'GL Account' },
    { field: 'accountName', header: 'Account Name' },
    { field: 'debitAmount', header: 'Debit', align: 'right', format: 'amount' },
    { field: 'creditAmount', header: 'Credit', align: 'right', format: 'amount' },
    { field: 'warehouseName', header: 'Warehouse' },
    { field: 'departmentName', header: 'Department' },
    { field: 'postedDate', header: 'Posted Date', format: 'date' },
  ];

  createOrderForm = new FormGroup({
    OrderNo: new FormControl('', Validators.required),
    manualEntry: new FormControl(false),
    BillToCustomerId: new FormControl('', Validators.required),
    ShipToCustomerId: new FormControl('', Validators.required),
    BillToCustomerCode: new FormControl('', Validators.required),
    ShipToCustomerCode: new FormControl('', Validators.required),
    BillToCustomer: new FormControl('', Validators.required),
    ShipToCustomer: new FormControl('', Validators.required),
    BillToCustomerAddress: new FormControl(''),
    ShipToCustomerAddress: new FormControl('', Validators.required),
    warehouse: new FormControl('', Validators.required),
    WareHouseId: new FormControl('', Validators.required),
    salesperson: new FormControl('', Validators.required),
    SalespersonCode: new FormControl('', Validators.required),
    SalespersonId: new FormControl('', Validators.required),
    CreatedBy: new FormControl('', Validators.required),
    // add product
    productId: new FormControl(''),
    productCode: new FormControl(''),
    productDescription: new FormControl(''),
    productQty: new FormControl(''),
    productWgt: new FormControl(''),
    productData: new FormControl(''),
    totalWeight: new FormControl(),
    ShipmentDate: new FormControl(),
    TermsCode: new FormControl(''),
    PaymentTermsId: new FormControl(),
    DispatchDocNo: new FormControl(''),
    MotorVehicalNo: new FormControl(),
    BillOfLading: new FormControl(),
    EwbNo: new FormControl(),
    purchaseOrderNumber: new FormControl(),
    LRRRNo: new FormControl(),
    DispatchThrough: new FormControl(),
    // OrderType: new FormControl('Q'),

    BillToCustomerState: new FormControl(''),
    warehouseState: new FormControl(''),
    warehouseStateCode: new FormControl(''),
    SalesOrderInvoiceDate: new FormControl<Date | null>(null),

    requestedDate: new FormControl<Date | null>(null, Validators.required),
    orderDate: new FormControl<Date | null>(null, Validators.required),
    deliveryNote: new FormControl(''),
    serviceCallCode: new FormControl(''),

    ReferenceNumber: new FormControl(),
    Destination: new FormControl(),
    TermsOfDelivery: new FormControl(),

    closedTime: new FormControl<null | Date>(null),
    IsClosed: new FormControl(false),
    CustomerPODate: new FormControl(),
    RateOnFreight: new FormControl(),
    DiscountAmount: new FormControl(),
    FreightTotal: new FormControl(),
    GSTOnFreight: new FormControl(),
    FinalTaxableAmt: new FormControl(),
    supplyType: new FormControl('', Validators.required),
    isLUT: new FormControl(false),
    expTyp: new FormControl(''),
    isRCM: new FormControl(false),
    //POS: new FormControl(''),

    POS: new FormControl(''),            // 👉 state CODE (for backend)
    POSDisplay: new FormControl(''),
    BillToCustomerStateCode: new FormControl(''),
    ShipToCustomerStateCode: new FormControl(''),
    ShipToCustomerState: new FormControl(''),
    FinancialYearId: new FormControl(),
    projectBoMId: new FormControl(null),
    projectName: new FormControl(''),
    projectNo: new FormControl(''),
  });

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  BillTocustomerList: any[] = [];
  ShipTocustomerList: any[] = [];
  warehouseDropdown: Warehouse[] = [];
  filterWarehouses: Warehouse[] = [];
  filterProductList: any[] = [];
  products: Product[] = [];    // Main product variable
  allProductData: Product[] = []; // Stores all product data even after deleting from the grid
  addProductData: any;        // Represents data for adding a new product
  selectedProduct: Product[] = [];   // // Stores data for deleted products
  deleteProductIds: any[] = [];
  IsClosed: [false] | undefined
  orderTotal: number = 0.00;
  weightTotal: number = 0.00;
  CGSTtotal: number = 0.00;
  SGSTtotal: number = 0.00;
  IGSTtotal: number = 0.00;
  SalesTaxTotal: number = 0.00;
  Taxable: number = 0.00;
  deletedProducts: any[] = [];
  creditLimitExceeded: boolean = false;
  showCreditDetails: boolean = false;
  exceededAmount: number = 0.00;
  invoiceAmount: number = 0.00;
  totalOutstanding: number = 0.00;
  customerCreditLimit: number = 0.00;
  FinalTaxableAmt: number = 0.00;
  NonTaxableTotal: number = 0.00;
  // ngOnInit(): void {
  //   this.reOpen();
  //   this.getWarehouse();
  //   this.createOrderForm.controls.CreatedBy.setValue(sessionStorage.getItem('username'));
  //   if (!this.isEdit)
  //     this.manualEntry();
  // }

  // ngOnInit(): void {
  //   document.title = 'Create Invoice';
  //   this.route.queryParams.subscribe(params => {
  //     if (params['Data']) {
  //       this.isEdit = true;
  //       document.title = 'Invoice';
  //       this.reOpen();
  //     } else {
  //       this.isEdit = false;
  //       this.resetForms();
  //       this.manualEntry();
  //     }
  //   });
  //   this.getWarehouse();
  //   this.getUserList();
  //   this.createOrderForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
  //   this.createOrderForm.controls.orderDate.setValue(new Date());
  //   this.createOrderForm.controls.requestedDate.setValue(new Date());
  //   const currentDate = new Date();
  //   this.deliveryDate = currentDate;
  //   this.getSystemConfigData();
  //   this.getSystemConfigDataForEmail();
  //   this.getCompanyDetails();
  //   if (this.isEdit) {
  //     // this.createOrderForm.controls['orderDate'].disable();
  //     // this.createOrderForm.controls['requestedDate'].disable();
  //   } else {
  //     this.createOrderForm.controls['orderDate'].enable();
  //   }
  //   this.inventoryService.getUnitByAppKey('unitNameLabel').subscribe((res: any) => {
  //     this.unitLabel = res?.data || 'Unit';
  //   });
  //   this.createOrderForm.get('DiscountAmount')?.valueChanges.subscribe(() => {
  //     this.calculateOrderTotal();
  //   });

  //   this.createOrderForm.get('GSTOnFreight')?.valueChanges.subscribe(() => {
  //     this.calculateOrderTotal();
  //   });

  //   this.createOrderForm.get('RateOnFreight')?.valueChanges.subscribe(() => {
  //     this.calculateFreightGST();
  //   });

  //   this.createOrderForm.get('FreightTotal')?.valueChanges.subscribe(() => {
  //     this.calculateFreightGST();
  //   });
  // }

  ngOnInit(): void {

    this.initPage();
    //this.initFormDefaults();
    this.loadMasterData();
    this.setupFormSubscriptions();

  }
  initPage() {

    document.title = 'Create Invoice';

    this.route.queryParams.subscribe(params => {

      if (params['Data']) {
        this.isEdit = true;
        document.title = 'Invoice';
        this.reOpen();
      } else {
        this.isEdit = false;
        this.resetForms();
        this.manualEntry();

        this.initFormDefaults();
      }

    });
  }

  private subscribeFinancialYearChanges() {

    this.createOrderForm.get('orderDate')?.valueChanges.subscribe(date => {

      //if (this.isInitializing) return;

      if (date instanceof Date) {
        this.onTransactionDateChange(date, "Order");
      }
    });

    this.createOrderForm.get('requestedDate')?.valueChanges.subscribe(date => {

      // if (this.isInitializing) return;

      if (date instanceof Date) {
        this.onTransactionDateChange(date, "Requested");
      }
    });

  }

  initFormDefaults() {

    this.createOrderForm.patchValue({
      CreatedBy: localStorage.getItem('username'),
      orderDate: new Date(),
      requestedDate: new Date()
    });

    this.deliveryDate = new Date();

    if (!this.isEdit) {
      this.createOrderForm.get('orderDate')?.enable();
    }

    // this.isInitializing = false;

    // Call once manually
    const orderDate = this.createOrderForm.get('orderDate')?.value;

    if (orderDate) {
      this.onTransactionDateChange(orderDate, "Order");
    }

    const requestedDate = this.createOrderForm.get('requestedDate')?.value;

    if (requestedDate) {
      this.onTransactionDateChange(requestedDate, "Requested");
    }

    this.subscribeFinancialYearChanges();

  }
  loadMasterData() {

    this.getWarehouse();
    this.getUserList();
    this.getSystemConfigData();
    this.getSystemConfigDataForEmail();
    this.getCompanyDetails();

    this.inventoryService.getUnitByAppKey('unitNameLabel')
      .subscribe((res: any) => {
        this.unitLabel = res?.data || 'Unit';
      });
  }

  private subscriptions: Subscription[] = [];

  setupFormSubscriptions() {

    const form = this.createOrderForm;

    // 🔥 All fields that affect GST / Tax logic
    const taxTriggers = [
      'supplyType',
      'isLUT',
      'isRCM',
      'BillToCustomerState',
      'ShipToCustomerState',
      'warehouseState'
    ];

    taxTriggers.forEach(field => {

      const sub = form.get(field)?.valueChanges
        .pipe(debounceTime(100)) // 🔥 prevents multiple rapid triggers
        .subscribe(() => {

          const value = form.value;

          // 🔥 Reset LUT + Export Type if not EXPORT/SEZ
          if (field === 'supplyType' &&
            value.supplyType !== 'EXPORT' &&
            value.supplyType !== 'SEZ') {

            form.patchValue({
              isLUT: false,
              expTyp: ''
            }, { emitEvent: false });
          }

          // 🔥 NEW: POS
          this.setPlaceOfSupply();

          // 🔥 Central business rules
          this.setExportType();
          //this.validateRCM();
          if (field === 'supplyType') {
            this.validateRCM();
          }


          // 🔥 Single calculation point
          this.calculateOrderTotal();
        });

      if (sub) this.subscriptions.push(sub);
    });


    // 🔹 Freight GST logic
    const freightRateSub = form.get('RateOnFreight')?.valueChanges
      .pipe(debounceTime(100))
      .subscribe(() => this.calculateFreightGST());

    const freightTotalSub = form.get('FreightTotal')?.valueChanges
      .pipe(debounceTime(100))
      .subscribe(() => this.calculateFreightGST());

    if (freightRateSub) this.subscriptions.push(freightRateSub);
    if (freightTotalSub) this.subscriptions.push(freightTotalSub);


    // 🔹 Discount affects total only
    const discountSub = form.get('DiscountAmount')?.valueChanges
      .pipe(debounceTime(100))
      .subscribe(() => this.calculateOrderTotal());

    if (discountSub) this.subscriptions.push(discountSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


  getUserList(): void {
    if (this.isEdit) {
      return;
    }
    //this.loader = true;
    this.administratorService.getAllUser().subscribe({
      next: (data: any) => {
        this.userList = data;
        this.setWarehouseFromSession();
        //this.loader = false;
      },
      error: error => {
        console.error('Error fetching user info:', error);
        //this.loader = false;
      }
    });
  }

  setWarehouseFromSession(): void {
    const authData = JSON.parse(localStorage.getItem('auth') || '{}');
    const userId = authData.user?.id;

    const user = this.userList.find((u: { userId: number; warehouseId?: number }) => u.userId === userId);
    if (user) {
      const warehouseId = user.warehouseId;
      if (warehouseId) {
        this.createOrderForm.controls.WareHouseId.setValue(warehouseId);
        this.setWarehouseName(warehouseId);
      } else {
        console.warn(`No warehouse ID found for user ID: ${userId}`);
      }
    } else {
      console.warn(`User not found with user ID: ${userId}`);
    }
  }

  setWarehouseName(warehouseId: number): void {
    const warehouse = this.warehouseDropdown.find(w => w.warehouseId === warehouseId);
    if (warehouse) {
      this.createOrderForm.controls.warehouse.setValue(warehouse.warehouseName);
      this.createOrderForm.controls.warehouseState.setValue(warehouse.address.state);
    }
  }


  resetForms() {
    this.createOrderForm.reset();
    this.createOrderForm.controls.manualEntry.setValue(false);
    this.orderTotal = 0;
    this.weightTotal = 0;
    this.CGSTtotal = 0;
    this.SGSTtotal = 0;
    this.IGSTtotal = 0;
    this.isIGST = false;
    this.products = [];
    this.allProductData = [];
    this.calculateOrderTotal();
  }

  get formControls() {
    return this.createOrderForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.createOrderForm.invalid) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill Required field' });
      isValid = false;
    }

    return isValid;
  }

  resetForm() {

    this.confirmationService.confirm({
      header: 'Reset',
      message: 'Reset will permanently delete all lines in the Order Line.',
      accept: () => {

        var selectedProductIds = this.products.map(product => product.SalesOrderLineItemId);

        this.loader = true;
        this.salesService.deleteSalesOrderLineItem(selectedProductIds).subscribe({
          next: async (data: any) => {
            if (data) {
              this.products = this.products.filter(product => !selectedProductIds.includes(product.SalesOrderLineItemId));
              this.selectedProduct = [];
              const isValid = this.calculateOrderTotal();
              if (await isValid) {
                this.createSalesOrder('TEMP.INVOICE');
              }
            }
          },
          error: error => {
            console.log(error);
            this.loader = false;
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while reset' });
          }
        });

      },
      reject: () => {
      }
    });

  }

  Cancel() {
    this.router.navigate(['/home/listInvoice']);
  }

  private navigateToInvoiceList(delayMs = 1500): void {
    setTimeout(() => {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/home/listInvoice']);
      });
    }, delayMs);
  }

  manualEntry() {
    const manualEntryValue = this.createOrderForm.controls.manualEntry.value;

    if (manualEntryValue === true) {
      this.createOrderForm.controls.OrderNo.setValue('');
    } else {
      this.getOrderNumber();
    }

  }

  getOrderNumber() {
    //this.loader = true;

    this.salesService.autogenerateInvoiceNumber().subscribe({
      next: (data: any) => {
        this.createOrderForm.controls.OrderNo.setValue(data.fullNumber);
        //this.loader = false;
      },
      error: (error) => {
        //this.loader = false;
        console.error('Failed to generate invoice number:', error);
      }
    });
  }

  checkOrderNumber() {
    if (!this.createOrderForm.controls.OrderNo.value) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Please enter' });
      return;
    }
    if (this.products.length > 0) {
      return;
    }
    if (!this.isEdit) {
      this.salesService.checkOrderNumber(this.createOrderForm.controls.OrderNo.value).subscribe(
        (data: any) => {
          if (data.success == true) {
            // console.log(data);
          } else {
            this.createOrderForm.controls.OrderNo.setValue('');
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Invoice number already exists.' });
            this.createOrderForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  // validateSalesOrder(value: string) {
  //   this.submitted = true;
  //   const isValid = this.validateForm();
  //   if (!isValid) {
  //     return;
  //   }

  //   if (this.products.length < 1) {
  //     this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
  //     const productCodeAutoCompleteElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
  //     if (productCodeAutoCompleteElement) {
  //       productCodeAutoCompleteElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //     }
  //     return;
  //   }

  //   for (const product of this.products) {
  //     if (!product.ProductDescription) {
  //       this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Product Name is Required' });
  //       return;
  //     }
  //   }

  //   if (!this.checkCreditLimitAndShowPopup()) {
  //     return;
  //   }

  //   this.createSalesOrder(value);
  // }

  async validateSalesOrder(value: string) {

    this.submitted = true;

    const isValid = this.validateForm();

    if (!isValid) {
      return;
    }

    if (!this.validateFinancialYear()) {
      return;
    }

    if (this.products.length < 1) {

      this.messageService.add({
        severity: 'error',
        summary: 'Warning',
        detail: 'Please enter product.'
      });

      const productCodeAutoCompleteElement =
        this.el.nativeElement.querySelector(
          '[formControlName="productCode"]'
        );

      if (productCodeAutoCompleteElement) {

        productCodeAutoCompleteElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

      return;
    }

    for (const product of this.products) {

      if (!product.ProductDescription) {

        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Value',
          detail: 'Product Name is Required'
        });

        return;
      }
    }

    // IMPORTANT
    // WAIT FOR CALCULATION

    await this.calculateOrderTotal();

    if (!this.checkCreditLimitAndShowPopup()) {
      return;
    }

    this.createSalesOrder(value);
  }

  checkCreditLimitAndShowPopup(): boolean {
    this.invoiceAmount = this.orderTotal;
    this.totalOutstanding = this.customer?.outstandingRec || 0;
    this.customerCreditLimit = this.customer?.creditLimit || 0;

    const noCreditCheckRaw = this.customer?.noCreditCheck;
    const creditCheck = noCreditCheckRaw === true || noCreditCheckRaw === 'true';

    if (!creditCheck) {
      const totalReceivables = this.totalOutstanding + this.invoiceAmount;
      if (totalReceivables > this.customerCreditLimit) {
        this.exceededAmount = totalReceivables - this.customerCreditLimit;
        this.creditLimitExceeded = true;
        return false;
      }
    }

    return true;
  }

  toggleDetails(event: Event) {
    event.preventDefault();
    this.showCreditDetails = !this.showCreditDetails;
  }

  closeCreditDialog() {
    this.creditLimitExceeded = false;
    this.showCreditDetails = false;
  }

  continueInvoiceCreation() {
    this.creditLimitExceeded = false;
    this.showCreditDetails = false;

    this.customer.outstandingRec = this.totalOutstanding + this.orderTotal;

    this.customerService.updateOutstandingReceivables(this.customer).subscribe({
      next: (data: any) => {
        console.log('Customer updated successfully.');
        this.loader = false;
      },
      error: (err: any) => {
        console.error('Failed to update customer:', err);
        this.loader = false;
      }
    });

    this.createSalesOrder('DRAFT.INVOICE');
  }


  // showBillToCustomerDialog() {
  //   const ref = this.dialogService.open(BillToCustomerLookupComponent, {
  //     header: 'Bill TO Customer List',
  //     width: '80%'
  //   });

  //   ref.onClose.subscribe((selectedCustomer: any) => {
  //     if (selectedCustomer) {
  //       this.createOrderForm.controls.BillToCustomerId.setValue(selectedCustomer.customerId);
  //       this.createOrderForm.controls.BillToCustomerCode.setValue(selectedCustomer.customerCode);
  //       this.createOrderForm.controls.BillToCustomer.setValue(selectedCustomer.customerName);
  //       this.createOrderForm.controls.BillToCustomerState.setValue(selectedCustomer.address.state);
  //       const address = `${selectedCustomer.address.addressLine1}, ${selectedCustomer.address.city, selectedCustomer.address.state}, ${selectedCustomer.address.country} ${selectedCustomer.address.zip}`;
  //       this.createOrderForm.controls.BillToCustomerAddress.setValue(address);
  //       this.selectedCustomerEmail = selectedCustomer.email;
  //       this.selectedCustomerName = selectedCustomer.customerName;
  //       this.getTermsByCustomer(selectedCustomer.customerCode);
  //       this.customer = selectedCustomer;
  //       this.customerEmail = selectedCustomer.email;

  //       if (selectedCustomer.isShipToCustomer) {
  //         this.createOrderForm.controls.ShipToCustomerCode.setValue(selectedCustomer.customerCode);
  //         this.createOrderForm.controls.ShipToCustomer.setValue(selectedCustomer.customerName);
  //         this.createOrderForm.controls.ShipToCustomerId.setValue(selectedCustomer.customerId);
  //         this.createOrderForm.controls.ShipToCustomerAddress.setValue(address);
  //       }

  //       // this.loadOutstandingAmount(selectedCustomer.customerId);


  //     }
  //   });
  // }

  showBillToCustomerDialog() {
    const ref = this.dialogService.open(BillToCustomerLookupComponent, {
      header: 'Bill TO Customer List',
      width: '80%'
    });

    // ref.onClose.subscribe((selectedCustomer: any) => {
    //   if (selectedCustomer) {
    //     this.createOrderForm.controls.BillToCustomerId.setValue(selectedCustomer.customerId);
    //     this.createOrderForm.controls.BillToCustomerCode.setValue(selectedCustomer.customerCode);
    //     this.createOrderForm.controls.BillToCustomer.setValue(selectedCustomer.customerName);
    //     this.createOrderForm.controls.BillToCustomerState.setValue(selectedCustomer.address.state);
    //     const address = `${selectedCustomer.address.addressLine1}, ${selectedCustomer.address.city, selectedCustomer.address.state}, ${selectedCustomer.address.country} ${selectedCustomer.address.zip}`;
    //     this.createOrderForm.controls.BillToCustomerAddress.setValue(address);
    //     this.selectedCustomerEmail = selectedCustomer.email;
    //     this.selectedCustomerName = selectedCustomer.customerName;
    //     this.getTermsByCustomer(selectedCustomer.customerCode);
    //     this.customer = selectedCustomer;
    //     this.customerEmail = selectedCustomer.email;

    //     if (selectedCustomer.isShipToCustomer) {
    //       this.createOrderForm.controls.ShipToCustomerCode.setValue(selectedCustomer.customerCode);
    //       this.createOrderForm.controls.ShipToCustomer.setValue(selectedCustomer.customerName);
    //       this.createOrderForm.controls.ShipToCustomerId.setValue(selectedCustomer.customerId);
    //       this.createOrderForm.controls.ShipToCustomerAddress.setValue(address);
    //     }

    //     // this.loadOutstandingAmount(selectedCustomer.customerId);


    //   }
    // });

    ref.onClose.subscribe((selectedCustomer: any) => {
      if (selectedCustomer) {

        this.applyBillToCustomer(selectedCustomer);

        this.getTermsByCustomer(selectedCustomer.customerCode);
      }
    });
  }


  getTermsByCustomer(CustomerCode: string) {
    this.paymentService.getTermByCustomer(CustomerCode).subscribe(
      (data: any) => {
        if (data.success) {
          const termsData = data.termsDetails
          this.createOrderForm.controls.TermsCode.setValue(termsData.paymentTermsDescription)
          this.createOrderForm.controls.PaymentTermsId.setValue(termsData.paymentTermsId)
        }
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while patch customer' });
      }
    );
  }


  // openShipToCustomerLookup() {
  //   const ref = this.dialogService.open(ShipToCustomerLookupComponent, {
  //     header: 'Ship To Customer List',
  //     width: '80%'
  //   });

  //   ref.onClose.subscribe((selectedCustomer: any) => {
  //     if (selectedCustomer) {
  //       this.createOrderForm.controls.ShipToCustomerId.setValue(selectedCustomer.customerId);
  //       this.createOrderForm.controls.ShipToCustomerCode.setValue(selectedCustomer.customerCode);
  //       this.createOrderForm.controls.ShipToCustomer.setValue(selectedCustomer.customerName);
  //       const address = `${selectedCustomer.address.addressLine1}, ${selectedCustomer.address.city, selectedCustomer.address.state}, ${selectedCustomer.address.country} ${selectedCustomer.address.zip}`;
  //       this.createOrderForm.controls.ShipToCustomerAddress.setValue(address);
  //     }
  //   });
  // }
  openShipToCustomerLookup() {

    const ref = this.dialogService.open(ShipToCustomerLookupComponent, {
      header: 'Ship To Customer List',
      width: '80%'
    });

    ref.onClose.subscribe((selectedCustomer: any) => {

      if (!selectedCustomer) return;

      const addressObj = selectedCustomer.address || {};

      // const address = `${addressObj.addressLine1 || ''}, 
      //                ${addressObj.city || ''}, 
      //                ${addressObj.state || ''}, 
      //                ${addressObj.country || ''} 
      //                ${addressObj.zip || ''}`;

      const address = `${addressObj.addressLine1}, ${addressObj.city}, ${addressObj.state}, ${addressObj.country} ${addressObj.zip}`;


      // 🔥 Patch everything at once
      this.createOrderForm.patchValue({
        ShipToCustomerId: selectedCustomer.customerId,
        ShipToCustomerCode: selectedCustomer.customerCode,
        ShipToCustomer: selectedCustomer.customerName,
        ShipToCustomerAddress: address,
        //ShipToCustomerState: addressObj.state || ''   // ✅ CRITICAL FOR POS

        //ShipToCustomerState: addressObj.state || '',
        ShipToCustomerState: addressObj.state || '',

        // ✅ For GST logic
        ShipToCustomerStateCode: addressObj.stateCode || ''
      });

      // 🔥 Immediately recalculate GST
      this.setPlaceOfSupply();     // POS update
      this.calculateOrderTotal();  // Tax update
    });
  }


  autosearchBilltoCustomer(event: any) {
    this.salesService.autoSearchCustomer(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.BillTocustomerList = data.filter((customer: any) => customer.isActive === true);
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  // setBillTo(data: any) {
  //   if (data.value) {
  //     this.createOrderForm.controls.BillToCustomerCode.setValue(data.value.customerCode);
  //     this.createOrderForm.controls.BillToCustomer.setValue(data.value.customerName);
  //     this.createOrderForm.controls.BillToCustomerId.setValue(data.value.customerId);
  //     const address = `${data.value.address.addressLine1}, ${data.value.address.city, data.value.address.state}, ${data.value.address.country} ${data.value.address.zip}`;
  //     this.createOrderForm.controls.BillToCustomerAddress.setValue(address);
  //     this.createOrderForm.controls.BillToCustomerState.setValue(data.value.address.state);
  //     this.customer = data.value;
  //     this.customerEmail = data.value.email;

  //     if (data.value.isShipToCustomer) {
  //       this.createOrderForm.controls.ShipToCustomerCode.setValue(data.value.customerCode);
  //       this.createOrderForm.controls.ShipToCustomer.setValue(data.value.customerName);
  //       this.createOrderForm.controls.ShipToCustomerId.setValue(data.value.customerId);
  //       this.createOrderForm.controls.ShipToCustomerAddress.setValue(address);
  //     }
  //     //this.loadOutstandingAmount(data.value.customerId);

  //   }
  // }
  setBillTo(event: any) {
    const customer = event?.value || event;

    this.applyBillToCustomer(customer);
  }


  applyBillToCustomer(customer: any) {

    if (!customer) return;

    const addressObj = customer.address || {};

    //console.log("FULL ADDRESS OBJECT:", addressObj);

    const address = `${addressObj.addressLine1}, ${addressObj.city}, ${addressObj.state}, ${addressObj.country} ${addressObj.zip}`;

    // 🔥 Patch Bill To (INCLUDING STATE CODE)
    this.createOrderForm.patchValue({
      BillToCustomerId: customer.customerId,
      BillToCustomerCode: customer.customerCode,
      BillToCustomer: customer.customerName,
      BillToCustomerAddress: address,

      // ✅ IMPORTANT
      BillToCustomerState: addressObj.state || '',
      BillToCustomerStateCode: addressObj.stateCode || ''  // ⭐ ADD THIS
    });

    this.customer = customer;
    this.customerEmail = customer.email;

    //  Ship To auto-fill
    if (customer.isShipToCustomer) {
      this.createOrderForm.patchValue({
        ShipToCustomerCode: customer.customerCode,
        ShipToCustomer: customer.customerName,
        ShipToCustomerId: customer.customerId,
        ShipToCustomerAddress: address,

        //  ALSO ADD HERE
        ShipToCustomerState: addressObj.state || '',
        ShipToCustomerStateCode: addressObj.stateCode || '' // ⭐ ADD THIS
      });
    }

    //  Supply Type
    const supplyType = this.getSupplyType(customer);

    this.createOrderForm.patchValue({
      supplyType: supplyType
    });

    //  GST logic
    this.setExportType();
    this.updateRCMState(supplyType);

    //  NEW: POS calculation (MUST ADD)
    this.setPlaceOfSupply();

    setTimeout(() => {
      this.calculateOrderTotal();
    });
  }





  // loadOutstandingAmount(customerId: number): void {
  //   if (!customerId) return;

  //   this.customerService.getOutstandingAmount(customerId.toString())
  //     .subscribe({
  //       next: (amount: number) => {
  //         this.outstandingReceivables = amount;
  //       },
  //       error: err => {
  //         console.error('Outstanding amount error', err);
  //         this.outstandingReceivables = 0;
  //       }
  //     });
  // }

  autosearchShiptoCustomer(event: any) {
    this.salesService.autoSearchCustomer(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.ShipTocustomerList = data.filter((customer: any) => customer.isShipToCustomer === true && customer.isActive === true);
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  setShipTo(data: any) {
    if (data.value) {
      this.createOrderForm.controls.ShipToCustomerCode.setValue(data.value.customerCode);
      this.createOrderForm.controls.ShipToCustomer.setValue(data.value.customerName);
      this.createOrderForm.controls.ShipToCustomerId.setValue(data.value.customerId);
      const address = `${data.value.address.addressLine1}, ${data.value.address.city, data.value.address.state}, ${data.value.address.country} ${data.value.address.zip}`;
      this.createOrderForm.controls.ShipToCustomerAddress.setValue(address);
    }
  }

  getWarehouse() {
    this.administratorService.getAllWarehouse(this.pageRequest).subscribe({
      next: (data: any) => {
        this.warehouseDropdown = data.warehouses;
        // console.log(data);
      },
      error: error => {
        console.log(error);
      }
    });
  }

  filterWarehouse(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.warehouseDropdown as any[]).length; i++) {
      let productType = (this.warehouseDropdown as any[])[i];
      if (productType.warehouseName.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        productType.warehouseCode.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(productType);
      }
    }

    this.filterWarehouses = filtered;
  }

  setWarehouse(data: any) {
    if (data.value) {
      this.createOrderForm.controls.WareHouseId.setValue(data.value.warehouseId);
      this.createOrderForm.controls.warehouseState.setValue(data.value.address.state);
    }
  }

  showSalesperson() {
    if (this.products.length > 0) {
      return;
    }

    this.ref = this.dialogService.open(SalespersonLookupComponent, {
      header: 'Salesperson List',
      width: '60%',

    });
    this.ref.onClose.subscribe((data: salesPerson) => {
      if (data) {
        this.createOrderForm.controls.SalespersonCode.setValue(data.salespersonCode);
        this.createOrderForm.controls.SalespersonId.setValue(_.toString(data.salespersonId));
        this.createOrderForm.controls.salesperson.setValue(data.salespersonName);
      }
    });
  }

  showTermsCode() {
    this.ref = this.dialogService.open(TermscodeLookupComponent, {
      header: 'Terms Code',
      width: '60%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.createOrderForm.patchValue({
          TermsCode: data.paymentTermsDescription,
          PaymentTermsId: data.paymentTermsId
        })
      }
    })
  }


  autosearchProduct(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.filterProductList = data;
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  setProduct(data: any) {
    this.createOrderForm.controls.productCode.setValue(data.value.productCode);
    this.createOrderForm.controls.productDescription.setValue(data.value.productName);
    this.createOrderForm.controls.productId.setValue(data.value.productId);
    this.addProductData = data.value;
    const costCalculationType = data.value.costCalculation || 'Qty';
    this.productCostCalculationType = costCalculationType;
    if (costCalculationType === 'Qty') {
      this.createOrderForm.controls.productQty.setValue('');
    } else if (costCalculationType === 'Wgt') {
      this.createOrderForm.controls.productWgt.setValue('');
    }
    this.setFieldFocus();

    if (data.value.productImage) {
      this.previewImage = `data:image/jpeg;base64,${data.value.productImage}`;
    } else {
      this.previewImage = "./assets/no-image.jpg";
    }
    this.getInventoryStatus(data.value.productCode);
  }

  setFieldFocus() {
    const control = this.el.nativeElement.querySelector('#Qty');
    if (control) {
      setTimeout(() => {
        control.focus();
      }, 100);
    }
  }



  validateCustomer() {
    let isValid = true;

    if (
      !this.createOrderForm.controls.BillToCustomer?.valid ||
      !this.createOrderForm.controls.ShipToCustomer?.valid ||
      !this.createOrderForm.controls.warehouse?.valid ||
      !this.createOrderForm.controls.SalespersonCode?.valid ||
      !this.createOrderForm.controls.OrderNo?.valid ||
      !this.createOrderForm.controls.BillToCustomer?.valid ||
      !this.createOrderForm.controls.ShipToCustomer?.valid ||
      !this.createOrderForm.controls.WareHouseId?.valid

    ) {
      if (!this.createOrderForm.controls.BillToCustomer.value) {
        this.createOrderForm.controls.BillToCustomerCode.setValue('');
      } else if (!this.createOrderForm.controls.ShipToCustomer.value) {
        this.createOrderForm.controls.ShipToCustomerCode.setValue('');
      } else if (!this.createOrderForm.controls.WareHouseId.value) {
        this.createOrderForm.controls.warehouse.setValue('');
      }
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill Required field' });
      isValid = false;
    }

    return isValid;
  }

  // Function to check IGST based on warehouse and customer states
  // async checkIGST() {
  //   const warehouseState = this.createOrderForm.controls.warehouseState.value;
  //   const CustomerState = this.createOrderForm.controls.BillToCustomerState.value;

  //   if (!warehouseState || !CustomerState) {
  //     this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed to calculate IGST due to missing state values' });
  //     return;
  //   }

  //   if (warehouseState == CustomerState) {
  //     this.isIGST = false;
  //   } else {
  //     this.isIGST = true;
  //   }
  // }

  async checkIGST() {

    const warehouseState =
      this.createOrderForm.get('warehouseState')?.value;

    const customerState =
      this.createOrderForm.get('BillToCustomerState')?.value;

    const supplyType =
      this.createOrderForm.get('supplyType')?.value;

    // =========================================
    // EXPORT / SEZ always IGST
    // =========================================

    const isExportSupply =
      supplyType === 'EXPORT' ||
      supplyType === 'SEZ';

    if (isExportSupply) {
      this.isIGST = true;
      return;
    }

    // =========================================
    // Validation
    // =========================================

    if (!warehouseState || !customerState) {

      this.isIGST = false;

      this.messageService.add({
        severity: 'error',
        summary: 'Failed',
        detail: 'Failed to calculate GST due to missing state values'
      });

      return;
    }

    // =========================================
    // Interstate / Intrastate
    // =========================================

    const sellerState =
      warehouseState.toString().trim();

    const buyerState =
      customerState.toString().trim();

    this.isIGST = sellerState !== buyerState;
  }

  // Function to add a product to the quote

  async addProduct() {
    if (this.loader) return;

    if (!this.validateFinancialYear()) {
      return;
    }

    this.submitted = true;
    const orderQuantity = _.toNumber(this.createOrderForm.controls.productWgt.value);

    if (this.isQAvailWarning) {
      if (orderQuantity > this.QAvail) {
        this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Product Qty not available.' });
        return;
      }
    }

    const { requestedDate: requestedDateValue, orderDate: orderDateValue } = this.createOrderForm.controls;
    if (requestedDateValue?.value && orderDateValue?.value) {
      const requestedDate = new Date(requestedDateValue.value);
      const orderDate = new Date(orderDateValue.value);
      requestedDate.setHours(0, 0, 0, 0);
      orderDate.setHours(0, 0, 0, 0);

      if (requestedDate < orderDate) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Date Range',
          detail: 'The requested date cannot be earlier than the order date.'
        });
        return;
      }
    }


    this.loader = true;
    // Check IGST
    await this.checkIGST();

    const isValid = this.validateCustomer();
    if (!isValid) {
      window.scroll(0, 0);
      this.loader = false;
      return;
    }

    const productId = _.toNumber(this.createOrderForm.controls.productId.value);
    let costCalculationType: string;

    this.inventoryService.getProductById(productId).subscribe({
      next: (productData) => {
        if (!productData) {
          console.error('Product data is empty');
          this.loader = false;
          return;
        }

        this.addProductData = {
          ...this.addProductData,
          productName: productData.productName || this.addProductData.productName,
          standardCost: productData.standardCost || this.addProductData.standardCost,
          productCode: productData.productCode || this.addProductData.productCode,
          hsnCode: productData.hsnCode || this.addProductData.hsnCode,
          gst: productData.gst?.gstRate,
          productSpecification: productData.productSpecification,
          isServiceType: productData.isServiceType,
        };
        costCalculationType = productData?.costCalculation || 'Qty';

        const lastItem = this.allProductData[this.allProductData.length - 1];
        const weight = _.toNumber(this.createOrderForm.controls.productWgt.value);
        const parseCurrency = (value: any): number => {
          return parseFloat((value ?? 0).toString().replace(/[₹,]/g, ''));
        };
        const salesPrice = parseCurrency(this.addProductData?.salesPrice);
        const standardCost = parseCurrency(this.addProductData?.standardCost);
        const deliveryDate = this.createOrderForm.controls.requestedDate.value;

        let extensionPrice: number;

        if (costCalculationType === 'Qty') {
          extensionPrice = orderQuantity * salesPrice;
        } else if (costCalculationType === 'Wgt') {
          extensionPrice = weight * salesPrice;
        } else {
          console.warn('Unknown costCalculation type:', costCalculationType);
          extensionPrice = 0;
        }

        const gstRate = this.addProductData.gst != null ? this.addProductData.gst : 0;

        const product: Product = <Product><unknown>{
          SalesOrderNumber: _.toString(this.createOrderForm.controls.OrderNo.value),
          ProductId: productId,
          OrderQuantity: costCalculationType === 'Wgt' ? 0 : orderQuantity,
          Uom: _.toString(this.addProductData.sellingUom),
          LineItemNumber: this.allProductData.length !== 0 ? this.allProductData[this.allProductData.length - 1].LineItemNumber + 1 : 1,
          IsTaxable: this.addProductData.isTaxable,
          StandardCost: standardCost,
          UnitPrice: salesPrice,
          ExtensionPrice: extensionPrice,
          Comment: "",
          deliveryDate: deliveryDate,
          GSTRate: gstRate,
          HSNCode: this.addProductData.hsnCode,
          Discount: 0,
          DiscountAmount: 0,
          NetAmount: _.round(extensionPrice, 2),
          CGST: (!this.isIGST) ? this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? orderQuantity : weight), gstRate, this.addProductData.isTaxable) / 2 : 0,
          SGST: (!this.isIGST) ? this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? orderQuantity : weight), gstRate, this.addProductData.isTaxable) / 2 : 0,
          IGST: (this.isIGST) ? this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? orderQuantity : weight), gstRate, this.addProductData.isTaxable) : 0,
          SalesTax: this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? orderQuantity : weight), gstRate, this.addProductData.isTaxable),
          LineTotal: _.round(extensionPrice + this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? orderQuantity : weight), gstRate, this.addProductData.isTaxable), 2),
          ShipedWeight: costCalculationType === 'Qty' ? 0 : weight,
          WareHouseId: _.toNumber(this.createOrderForm.controls.WareHouseId.value),
          ProductCode: this.addProductData.productCode,
          ProductDescription: this.addProductData.productName,
          ProductSpecification: this.addProductData.productSpecification,
          CreatedBy: _.toString(this.createOrderForm.controls.CreatedBy.value),
          IsActive: true,
          DepartmentId: 0,
          LocationId: 0,
          SerialId: 0,
          VendnorId: 0,
          BackOrderOrderNumber: 0,
          IsServiceType: !!this.addProductData.isServiceType,
        };


        if (this.isEdit) {
          this.products.push(product);
          this.allProductData.push(product);
          this.calculateOrderTotal();
        } else {
          this.createSalesOrderLineItem(product);
          this.products = [...this.products, product];
        }

        this.createOrderForm.controls.productCode.setValue('');
        this.createOrderForm.controls.productDescription.setValue('');
        this.createOrderForm.controls.productQty.setValue('');
        this.createOrderForm.controls.productWgt.setValue('');
        this.previewImage = "./assets/no-image.jpg";
        this.loader = false;
        this.QAvail = 0;
        setTimeout(() => {
          const inputEl: HTMLInputElement = this.productCodeInputRef?.el?.nativeElement?.querySelector('input');
          inputEl?.focus();
        }, 0);
      }

    });
  }

  getProductById(productId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.inventoryService.getProductById(this.productId || productId).subscribe({
        next: (data: any) => resolve(data),
        error: (error) => reject(error),
      });
    });
  }


  // Function to create a sales order line item in the database
  createSalesOrderLineItem(product: Product) {
    this.salesService.createSalesOrderLineItem(product).subscribe(
      async (data: any) => {
        if (data) {
          // console.log(data);
          product.SalesOrderLineItemId = data.lineItemId;
          // this.products.push(product);
          this.createOrderForm.controls.productCode.setValue('');
          this.createOrderForm.controls.productDescription.setValue('')
          this.createOrderForm.controls.productQty.setValue('')
          this.createOrderForm.controls.productWgt.setValue('')
          this.loader = false;
          const isValid = this.calculateOrderTotal();
          // Create a sales order with a temporary status
          if (await isValid) {
            this.createSalesOrder('TEMP.INVOICE');
          }
          this.allProductData.push(product);
        }
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while adding product' });
      }
    );
  }


  // Function to create a sales order
  async createSalesOrder(value: string, MoveToShipping: boolean = false) {
    for (const product of this.products) {
      const validProductId = product.ProductId || this.productId;
      if (!validProductId) {
        this.messageService.add({ severity: 'error', summary: 'Invalid Product', detail: 'Product ID is missing.' });
        this.loader = false;
        return;
      }
      let productData;
      try {
        productData = await this.getProductById(validProductId);
      } catch (error) {
        console.error('Error fetching product data:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch product data.' });
        this.loader = false;
        return;
      }

      const costCalculationType = productData.costCalculation || 'Qty';

      if (costCalculationType === 'Qty' && product.OrderQuantity <= 0) {
        this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'OrderQuantity must be greater than 0.' });
        this.loader = false;
        return;
      }

      if (costCalculationType === 'Wgt' && product.Weight <= 0) {
        this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Weight must be greater than 0.' });
        this.loader = false;
        return;
      }
    }


    const SalesOrder: SalesOrder = <SalesOrder><unknown>{
      SalesOrderNumber: _.toString(this.createOrderForm.controls.OrderNo.value),
      OrderType: "ORDERTYPE.NORMAL",
      SalesOrderStatus: this.isEdit ? 'DRAFT.INVOICE' : value,
      SalesOrderDate: getISTDateWithCurrentTime(new Date()),
      SalesOrderInvoiceDate: getISTDateWithCurrentTime(new Date()),
      // ShipmentDate: this.createOrderForm.controls.ShipmentDate.value,
      SalespersonId: this.createOrderForm.controls.SalespersonId.value,
      SalespersonCode: this.createOrderForm.controls.SalespersonCode.value,
      CustomerId: this.createOrderForm.controls.BillToCustomerId.value,
      BillToCustomerCode: this.createOrderForm.controls.BillToCustomerCode.value,
      BillToCustomerId: this.createOrderForm.controls.BillToCustomerId.value,
      ShipToCustomerCode: this.createOrderForm.controls.ShipToCustomerCode.value,
      ShipToCustomerId: this.createOrderForm.controls.ShipToCustomerId.value,
      WarehouseId: this.createOrderForm.controls.WareHouseId.value,
      //OrderTotal: this.orderTotal,
      OrderTotal: _.round(this.orderTotal || 0, 2),
      totalWeight: this.weightTotal,
      // CGSTTotal: this.CGSTtotal,
      // SGSTTotal: this.CGSTtotal,
      // IGSTTotal: this.IGSTtotal,
      // SalesTaxTotal: this.CGSTtotal + this.CGSTtotal + this.IGSTtotal,

      CGSTTotal: _.round(this.CGSTtotal || 0, 2),

      SGSTTotal: _.round(this.SGSTtotal || 0, 2),

      IGSTTotal: _.round(this.IGSTtotal || 0, 2),

      SalesTaxTotal: _.round(
        (this.CGSTtotal || 0) +
        (this.SGSTtotal || 0) +
        (this.IGSTtotal || 0),
        2
      ),

      IsActive: true,
      CreatedBy: this.createOrderForm.controls.CreatedBy.value,
      MotorVehicleNo: this.createOrderForm.controls.MotorVehicalNo.value,
      deliveryNote: this.createOrderForm.controls.deliveryNote.value,
      TermsCode: this.createOrderForm.controls.TermsCode.value,
      PaymentTermsId: this.createOrderForm.controls.PaymentTermsId.value,
      DispatchDocNo: this.createOrderForm.controls.DispatchDocNo.value,
      BillOfLading: this.createOrderForm.controls.BillOfLading.value,
      EwbNo: this.createOrderForm.controls.EwbNo.value,
      PurchaseOrderNumber: this.createOrderForm.controls.purchaseOrderNumber.value,
      LRRRNo: this.createOrderForm.controls.LRRRNo.value,
      DispatchThrough: this.createOrderForm.controls.DispatchThrough.value,

      ReferenceNumber: this.createOrderForm.controls.ReferenceNumber.value,
      Destination: this.createOrderForm.controls.Destination.value,
      TermsOfDelivery: this.createOrderForm.controls.TermsOfDelivery.value,
      RateOnFreight: this.createOrderForm.controls.RateOnFreight.value || 0,
      DiscountAmount: this.createOrderForm.controls.DiscountAmount.value || 0,
      FreightTotal: this.createOrderForm.controls.FreightTotal.value || 0,
      GSTOnFreight: this.createOrderForm.controls.GSTOnFreight.value || 0,
      //FinalTaxableAmt: this.createOrderForm.controls.FinalTaxableAmt.value || 0,
      FinalTaxableAmt: _.round(this.FinalTaxableAmt || 0, 2),
      BackOrderTotal: 0,
      MarginTotal: 0,
      ProfitTotal: 0,
      LabourTotal: 0,
      // FreightTotal: 0,
      orderDate: this.createOrderForm.controls.orderDate.value ? getISTDateWithCurrentTime(this.createOrderForm.controls.orderDate.value) : null,
      requestedDate: this.createOrderForm.controls.requestedDate.value ? getISTDateWithCurrentTime(this.createOrderForm.controls.requestedDate.value) : null,
      CustomerPODate: this.createOrderForm.controls.CustomerPODate.value ? getISTDateWithCurrentTime(this.createOrderForm.controls.CustomerPODate.value) : null,
      Status: "Draft",
      ShipmentDate: this.createOrderForm.controls.ShipmentDate.value ? getISTDateWithCurrentTime(this.createOrderForm.controls.ShipmentDate.value) : null,
      SupplyType: this.createOrderForm.controls.supplyType.value,
      IsLUT: this.createOrderForm.controls.isLUT.value,
      ExportType: this.createOrderForm.controls.expTyp.value,
      IsRCM: this.createOrderForm.controls.isRCM.value,
      POS: this.createOrderForm.controls.POS.value,
      FinancialYearId: Number(this.createOrderForm.controls['FinancialYearId'].value),
      projectBoMId: this.createOrderForm.controls.projectBoMId.value ?? undefined,
      projectName: this.createOrderForm.controls.projectName.value ?? undefined,
      projectNo: this.createOrderForm.controls.projectNo.value ?? undefined,
    };

    // 🔹 Validate requestedDate >= orderDate
    if (SalesOrder.requestedDate && SalesOrder.orderDate) {
      const reqDate = new Date(SalesOrder.requestedDate);
      const ordDate = new Date(SalesOrder.orderDate);
      reqDate.setHours(0, 0, 0, 0);
      ordDate.setHours(0, 0, 0, 0);

      if (reqDate.getTime() < ordDate.getTime()) {
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Date Range',
          detail: 'The requested date cannot be earlier than the order date.'
        });
        return;
      }
    }

    if (MoveToShipping) {
      SalesOrder.SalesOrderStatus = 'SHIPPING';
      SalesOrder.Status = "Draft";
    }

    this.loader = true;

    // Background sync to ensure distributed header discounts are saved to DB
    if (this.products.length > 0) {
      const updateRequests = this.products.map(p => {
        const payload = {
          ...p,
          NetAmount: _.round(p.NetAmount || 0, 2),
          LineTotal: _.round(p.LineTotal || 0, 2),
          DiscountAmount: _.round(p.DiscountAmount || 0, 2)
        };
        return this.salesService.updateSalesOrderLineItem(payload);
      });
      forkJoin(updateRequests).subscribe({
        error: (err) => console.error("Error syncing line items", err)
      });
    }

    if (this.products.length === 1 && value === 'TEMP.INVOICE' && !this.isEdit) {
      this.salesService.createSalesOrder(SalesOrder).subscribe(
        (data: any) => {
          this.loader = false;
          if (data.success !== true) {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed to create invoice.' });
          }
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
        }
      );
    } else {
      if (this.isEdit) {
        SalesOrder.UpdatedBy = this.createOrderForm.controls.CreatedBy.value || '';
        SalesOrder.Status = "Draft";

        SalesOrder.TermsCode = this.createOrderForm.get('TermsCode')?.value || '';

        SalesOrder.PaymentTermsId = this.createOrderForm.get('PaymentTermsId')?.value ?? null;
      }


      this.salesService.updateSalesOrderNew(SalesOrder).subscribe(
        (data: any) => {
          this.loader = false;
          if (data && value === 'DRAFT.INVOICE') {
            this.updateInventoryNew('INVOICE_DRAFT');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Draft Invoice Updated Successfully.', life: 4000 });
            this.navigateToInvoiceList();
          }
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
          if (value === 'DRAFT.INVOICE') {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed To Create Invoice.' });
          }
        }
      );
    }
  }


  // sendOrderEmail() {
  //   if (!this.selectedCustomerEmail) {
  //     console.error('No customer email available.');
  //     return;
  //   }

  //   const emailData = {
  //     emailToId: this.selectedCustomerEmail,
  //     emailToName: this.selectedCustomerName,
  //     emailSubject: "Order Notification",
  //     emailBody: `Invoice Order Created Successfully`
  //   };

  //   this.salesService.SendMail(emailData).subscribe({
  //     next: (response: any) => {
  //       console.log('Email sent successfully', response);
  //     },
  //     error: (error: any) => {
  //       console.error('Error sending email', error);
  //     }
  //   });
  // }

  isLineDiscountDisabled(): boolean {
    const discountAmount = Number(this.createOrderForm.get('DiscountAmount')?.value) || 0;
    return discountAmount > 0;
  }

  checkLineItemDiscounts() {
    const hasLineDiscount = this.products.some(p => Number(p.Discount) > 0);
    const discountControl = this.createOrderForm.get('DiscountAmount');
    if (hasLineDiscount) {
      discountControl?.setValue(0, { emitEvent: false });
      discountControl?.disable({ emitEvent: false });
    } else {
      discountControl?.enable({ emitEvent: false });
    }
    this.calculateOrderTotal();
  }

  // Function to calculate the total amount of the order
  // async calculateOrderTotal() {
  //   await this.checkIGST();

  //   let totalWeight = 0;
  //   let taxableTotal = 0;
  //   let cgst = 0;
  //   let sgst = 0;
  //   let igst = 0;

  //   const getNum = (val: any) => _.toNumber(val) || 0;
  //   const parseCurrency = (val: any) =>
  //     parseFloat((val ?? 0).toString().replace(/[₹,]/g, '') || '0');

  //   // First pass to get total amount before header discount
  //   let totalBeforeHeaderDiscount = 0;
  //   for (const p of this.products) {
  //     const qty = getNum(p.OrderQuantity);
  //     const weight = getNum(p.Weight) || getNum(p.ShipedWeight);
  //     const unitPrice = parseCurrency(p.UnitPrice);
  //     const lineDiscount = getNum(p.Discount) || 0;

  //     const costType = (await this.getProductById(Number(p.ProductId)))?.costCalculation || 'Qty';
  //     const amount = _.round(costType === 'Qty' ? qty * unitPrice : weight * unitPrice, 2);

  //     p.Amount = amount;
  //     p.Discount = lineDiscount;
  //     p.DiscountAmount = lineDiscount;
  //     p.ExtensionPrice = amount;

  //     totalBeforeHeaderDiscount += _.round(amount - lineDiscount, 2);
  //   }

  //   const hasLineDiscount = this.products.some(p => Number(p.Discount) > 0);

  //   const discountControl = this.createOrderForm.get('DiscountAmount');
  //   if (hasLineDiscount) {
  //     if (discountControl?.enabled) {
  //       discountControl.setValue(0, { emitEvent: false });
  //       discountControl.disable({ emitEvent: false });
  //     }
  //   } else {
  //     if (discountControl?.disabled) {
  //       discountControl.enable({ emitEvent: false });
  //     }
  //   }

  //   const orderDiscount = hasLineDiscount
  //     ? 0
  //     : getNum(discountControl?.value);

  //   // Second pass to calculate distribution
  //   for (const product of this.products) {
  //     const quantity = getNum(product.OrderQuantity);
  //     const amount = product.Amount || 0;
  //     const lineDiscount = product.Discount || 0;
  //     const afterLineDiscount = _.round(amount - lineDiscount, 2);

  //     const lineHeaderDiscountShare = (totalBeforeHeaderDiscount > 0 && orderDiscount > 0)
  //       ? _.round((afterLineDiscount / totalBeforeHeaderDiscount) * orderDiscount, 2)
  //       : 0;

  //     const netAmount = _.round(afterLineDiscount - lineHeaderDiscountShare, 2);
  //     product.NetAmount = netAmount;
  //     product.DiscountAmount = lineDiscount + lineHeaderDiscountShare;

  //     taxableTotal += netAmount;

  //     const isTaxable =
  //       (typeof product.IsTaxable === 'string' && product.IsTaxable === 'Y') ||
  //       (typeof product.IsTaxable === 'boolean' && product.IsTaxable);

  //     const gstRate = getNum(product.GSTRate) || 0;

  //     if (isTaxable) {
  //       let taxAmount = 0;
  //       if (gstRate > 0) {
  //         taxAmount = _.round((netAmount * gstRate) / 100, 2);

  //         if (this.isIGST) {
  //           igst += taxAmount;
  //         } else {
  //           cgst += _.round(taxAmount / 2, 2);
  //           sgst += _.round(taxAmount / 2, 2);
  //         }
  //       }

  //       product.SalesTax = taxAmount;
  //       product.CGST = this.isIGST ? 0 : _.round(taxAmount / 2, 2);
  //       product.SGST = this.isIGST ? 0 : _.round(taxAmount / 2, 2);
  //       product.IGST = this.isIGST ? taxAmount : 0;
  //     } else {
  //       product.SalesTax = 0;
  //       product.CGST = 0;
  //       product.SGST = 0;
  //       product.IGST = 0;
  //     }

  //     product.LineTotal = _.round(netAmount + product.SalesTax, 2);
  //     totalWeight += quantity;
  //   }

  //   const freightTotal = _.round(getNum(this.createOrderForm.get('FreightTotal')?.value) || 0, 2);
  //   const gstOnFreightRate = _.round(getNum(this.createOrderForm.get('RateOnFreight')?.value) || 0, 2);

  //   let freightGST = 0;
  //   if (freightTotal > 0 && gstOnFreightRate > 0) {
  //     freightGST = _.round((freightTotal * gstOnFreightRate) / 100, 2);
  //     if (this.isIGST) {
  //       igst += freightGST;
  //     } else {
  //       cgst += _.round(freightGST / 2, 2);
  //       sgst += _.round(freightGST / 2, 2);
  //     }
  //   }

  //   const maxDiscount = _.round(totalBeforeHeaderDiscount + freightTotal, 2);

  //   if (!hasLineDiscount && orderDiscount > maxDiscount && maxDiscount > 0) {
  //     if (discountControl?.dirty && !discountControl?.hasError('exceedTotal')) {
  //       this.messageService.clear();
  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Invalid Discount',
  //         detail: `Discount cannot be greater than order total.`
  //       });
  //     }
  //     discountControl?.setErrors({ exceedTotal: true });
  //   } else {
  //     if (discountControl?.hasError('exceedTotal')) {
  //       discountControl.setErrors(null);
  //     }
  //   }

  //   const finalTaxableAmt = _.round(taxableTotal + freightTotal, 2);
  //   const totalOrder = _.round(finalTaxableAmt + cgst + sgst + igst, 2);

  //   this.weightTotal = _.round(totalWeight, 2);
  //   this.Taxable = _.round(taxableTotal, 2);
  //   this.NonTaxableTotal = 0;
  //   this.FinalTaxableAmt = _.round(finalTaxableAmt, 2);

  //   this.CGSTtotal = this.isIGST ? 0 : _.round(cgst, 2);
  //   this.SGSTtotal = this.isIGST ? 0 : _.round(sgst, 2);
  //   this.IGSTtotal = this.isIGST ? _.round(igst, 2) : 0;
  //   this.orderTotal = _.round(totalOrder, 2);

  //   this.products = _.cloneDeep(this.products);

  //   return true;
  // }

  // async calculateOrderTotal() {

  //   const form = this.createOrderForm.value;

  //   //const isIGST = this.isIGSTApplicable();

  //   const supplyType = form.supplyType;

  //   const isExportSupply =
  //     supplyType === 'EXPORT' ||
  //     supplyType === 'SEZ';

  //   const isIGST =
  //     isExportSupply || this.isIGSTApplicable();

  //   const isLUT =
  //     form.isLUT &&
  //     (form.supplyType === 'EXPORT' || form.supplyType === 'SEZ');

  //   const isRCM = form.isRCM === true;

  //   let totalWeight = 0;
  //   let taxableTotal = 0;
  //   let nonTaxableTotal = 0;

  //   let cgst = 0;
  //   let sgst = 0;
  //   let igst = 0;

  //   const parseAmount = (val: any) =>
  //     parseFloat((val || 0).toString().replace(/[₹,]/g, ''));

  //   const round = (num: number) =>
  //     Math.round((num + Number.EPSILON) * 100) / 100;

  //   const productCache = new Map<number, any>();

  //   const getProduct = async (productId: number) => {
  //     if (!productCache.has(productId)) {
  //       const data = await this.getProductById(productId);
  //       productCache.set(productId, data);
  //     }
  //     return productCache.get(productId);
  //   };

  //   for (const product of this.products) {

  //     const qty = Number(product.OrderQuantity) || 0;
  //     const weight = Number(product.Weight) || 0;
  //     const unitPrice = parseAmount(product.UnitPrice);

  //     const productData = await getProduct(Number(product.ProductId));
  //     const costType = productData?.costCalculation || 'Qty';

  //     const originalAmount = costType === 'Qty'
  //       ? qty * unitPrice
  //       : weight * unitPrice;


  //     const discountRate = Number(product.Discount) || 0;

  //     const discountAmount = round(
  //       originalAmount * (discountRate / 100)
  //     );

  //     const lineAmount = round(
  //       originalAmount - discountAmount
  //     );

  //     product.Amount = round(originalAmount);
  //     product.DiscountAmount = round(discountAmount);
  //     product.NetAmount = round(lineAmount);

  //     const isTaxable =
  //       (typeof product.IsTaxable === 'string' && product.IsTaxable === 'Y') ||
  //       (typeof product.IsTaxable === 'boolean' && product.IsTaxable === true);

  //     let productCGST = 0;
  //     let productSGST = 0;
  //     let productIGST = 0;

  //     if (isTaxable) {

  //       taxableTotal += lineAmount;

  //       const gstRate = Number(product.GSTRate) || 0;

  //       if (gstRate > 0 && !isLUT && !isRCM)
  //       //if (gstRate > 0 && !isLUT) 
  //       {

  //         const gstAmount = round(lineAmount * gstRate / 100);

  //         if (isIGST) {

  //           productIGST = gstAmount;
  //           igst += gstAmount;

  //         } else {

  //           productCGST = round(gstAmount / 2);
  //           productSGST = round(gstAmount / 2);

  //           cgst += productCGST;
  //           sgst += productSGST;
  //         }
  //       }

  //     } else {

  //       nonTaxableTotal += lineAmount;
  //     }

  //     product.CGST = round(productCGST);
  //     product.SGST = round(productSGST);
  //     product.IGST = round(productIGST);

  //     product.TaxableAmount = round(lineAmount);

  //     product.SalesTax = round(
  //       product.CGST +
  //       product.SGST +
  //       product.IGST
  //     );

  //     product.LineTotal = round(
  //       lineAmount + product.SalesTax
  //     );

  //     // product.ExtensionPrice = product.LineTotal;
  //     product.ExtensionPrice = round(originalAmount);

  //     totalWeight += costType === 'Qty'
  //       ? qty
  //       : weight;
  //   }

  //   const freight = parseAmount(
  //     this.createOrderForm.get('FreightTotal')?.value
  //   );

  //   const freightRate = parseAmount(
  //     this.createOrderForm.get('RateOnFreight')?.value
  //   );

  //   let freightGST = round(
  //     freight * (freightRate / 100)
  //   );

  //   if (freightGST > 0 && !isLUT && !isRCM) {

  //     if (isIGST) {

  //       igst += freightGST;

  //     } else {

  //       cgst += round(freightGST / 2);
  //       sgst += round(freightGST / 2);
  //     }
  //   }


  //   const discountControl =
  //     this.createOrderForm.get('DiscountAmount');

  //   const discount = parseAmount(
  //     discountControl?.value
  //   );

  //   const maxDiscount =
  //     taxableTotal +
  //     nonTaxableTotal +
  //     freight +
  //     cgst +
  //     sgst +
  //     igst;

  //   if (discount > maxDiscount && maxDiscount > 0) {

  //     if (
  //       discountControl?.dirty &&
  //       !discountControl?.hasError('exceedTotal')
  //     ) {

  //       this.messageService.clear();

  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Invalid Discount',
  //         detail: 'Discount cannot be greater than order total.'
  //       });
  //     }

  //     discountControl?.setErrors({
  //       exceedTotal: true
  //     });

  //   } else {

  //     discountControl?.setErrors(null);
  //   }


  //   // const finalTaxableAmt =
  //   //   taxableTotal +
  //   //   freight -
  //   //   (discount > maxDiscount ? 0 : discount);

  //   const finalTaxableAmt =
  //     round(
  //       taxableTotal +
  //       freight -
  //       (discount > maxDiscount ? 0 : discount)
  //     );

  //   // const totalOrder =
  //   //   finalTaxableAmt +
  //   //   nonTaxableTotal +
  //   //   cgst +
  //   //   sgst +
  //   //   igst;

  //   const totalOrder =
  //     round(
  //       finalTaxableAmt +
  //       nonTaxableTotal +
  //       cgst +
  //       sgst +
  //       igst
  //     );

  //   this.weightTotal = round(totalWeight);

  //   this.Taxable = round(taxableTotal);

  //   this.NonTaxableTotal = round(nonTaxableTotal);

  //   this.FinalTaxableAmt = round(finalTaxableAmt);

  //   this.CGSTtotal = isIGST
  //     ? 0
  //     : round(cgst);

  //   this.SGSTtotal = isIGST
  //     ? 0
  //     : round(sgst);

  //   this.IGSTtotal = isIGST
  //     ? round(igst)
  //     : 0;

  //   this.orderTotal = round(totalOrder);

  //   // 🔥 Refresh UI
  //   this.products = _.cloneDeep(this.products);

  //   return true;
  // }

  // async calculateOrderTotal() {

  //   const form = this.createOrderForm.value;

  //   const supplyType = form.supplyType;

  //   const isExportSupply =
  //     supplyType === 'EXPORT' ||
  //     supplyType === 'SEZ';

  //   const isIGST =
  //     isExportSupply ||
  //     this.isIGSTApplicable();

  //   const isLUT =
  //     form.isLUT &&
  //     (
  //       supplyType === 'EXPORT' ||
  //       supplyType === 'SEZ'
  //     );

  //   let totalWeight = 0;

  //   let taxableTotal = 0;

  //   let nonTaxableTotal = 0;

  //   let cgst = 0;
  //   let sgst = 0;
  //   let igst = 0;

  //   const parseAmount = (val: any) =>
  //     parseFloat(
  //       (val || 0)
  //         .toString()
  //         .replace(/[₹,]/g, '')
  //     );

  //   const round = (num: number) =>
  //     Math.round(
  //       (num + Number.EPSILON) * 100
  //     ) / 100;

  //   const freight =
  //     parseAmount(
  //       form.FreightTotal
  //     );

  //   const freightRate =
  //     parseAmount(
  //       form.RateOnFreight
  //     );

  //   const headerDiscount =
  //     parseAmount(
  //       form.DiscountAmount
  //     );

  //   const subtotalBeforeHeaderDiscount =
  //     this.products.reduce((sum, p) => {

  //       const qty =
  //         Number(p.OrderQuantity) || 0;

  //       const price =
  //         Number(p.UnitPrice) || 0;

  //       return sum + (qty * price);

  //     }, 0);

  //   const productCache =
  //     new Map<number, any>();

  //   const getProduct = async (
  //     productId: number
  //   ) => {

  //     if (!productCache.has(productId)) {

  //       const data =
  //         await this.getProductById(productId);

  //       productCache.set(productId, data);
  //     }

  //     return productCache.get(productId);
  //   };

  //   for (const product of this.products) {

  //     const qty =
  //       Number(product.OrderQuantity) || 0;

  //     const weight =
  //       Number(product.Weight) || 0;

  //     const unitPrice =
  //       parseAmount(product.UnitPrice);

  //     const productData =
  //       await getProduct(
  //         Number(product.ProductId)
  //       );

  //     const costType =
  //       productData?.costCalculation || 'Qty';

  //     const originalAmount =
  //       costType === 'Qty'
  //         ? qty * unitPrice
  //         : weight * unitPrice;

  //     const lineDiscountPercent =
  //       Number(product.Discount) || 0;

  //     const lineDiscountAmount =
  //       round(
  //         originalAmount *
  //         lineDiscountPercent / 100
  //       );

  //     const lineAmount =
  //       round(
  //         originalAmount -
  //         lineDiscountAmount
  //       );

  //     const proportionalHeaderDiscount =
  //       subtotalBeforeHeaderDiscount > 0
  //         ? round(
  //           (
  //             lineAmount /
  //             subtotalBeforeHeaderDiscount
  //           ) * headerDiscount
  //         )
  //         : 0;

  //     const finalLineAmount =
  //       round(
  //         lineAmount -
  //         proportionalHeaderDiscount
  //       );

  //     product.Amount =
  //       round(originalAmount);

  //     product.DiscountAmount =
  //       round(
  //         lineDiscountAmount +
  //         proportionalHeaderDiscount
  //       );

  //     product.NetAmount =
  //       round(finalLineAmount);

  //     const isTaxable =
  //       (
  //         typeof product.IsTaxable === 'string' &&
  //         product.IsTaxable === 'Y'
  //       ) ||
  //       (
  //         typeof product.IsTaxable === 'boolean' &&
  //         product.IsTaxable === true
  //       );

  //     let productCGST = 0;
  //     let productSGST = 0;
  //     let productIGST = 0;

  //     if (isTaxable) {

  //       taxableTotal += finalLineAmount;

  //       const gstRate =
  //         Number(product.GSTRate) || 0;

  //       if (gstRate > 0 && !isLUT) {

  //         const gstAmount =
  //           round(
  //             finalLineAmount *
  //             gstRate / 100
  //           );

  //         if (isIGST) {

  //           productIGST = gstAmount;

  //           igst += gstAmount;

  //         } else {

  //           productCGST =
  //             round(gstAmount / 2);

  //           productSGST =
  //             round(gstAmount / 2);

  //           cgst += productCGST;
  //           sgst += productSGST;
  //         }
  //       }

  //     } else {

  //       nonTaxableTotal += finalLineAmount;
  //     }

  //     product.CGST =
  //       round(productCGST);

  //     product.SGST =
  //       round(productSGST);

  //     product.IGST =
  //       round(productIGST);

  //     product.SalesTax =
  //       round(
  //         product.CGST +
  //         product.SGST +
  //         product.IGST
  //       );

  //     product.TaxableAmount =
  //       round(finalLineAmount);

  //     product.LineTotal =
  //       round(
  //         finalLineAmount +
  //         product.SalesTax
  //       );

  //     product.ExtensionPrice =
  //       round(originalAmount);

  //     totalWeight +=
  //       costType === 'Qty'
  //         ? qty
  //         : weight;
  //   }

  //   let freightGST =
  //     round(
  //       freight *
  //       freightRate / 100
  //     );

  //   if (freightGST > 0 && !isLUT) {

  //     if (isIGST) {

  //       igst += freightGST;

  //     } else {

  //       cgst +=
  //         round(freightGST / 2);

  //       sgst +=
  //         round(freightGST / 2);
  //     }
  //   }

  //   const finalTaxableAmt =
  //     round(
  //       this.products.reduce(
  //         (sum, p) =>
  //           sum + (p.NetAmount || 0),
  //         0
  //       ) + freight
  //     );

  //   const totalOrder =
  //     round(
  //       finalTaxableAmt +
  //       nonTaxableTotal +
  //       cgst +
  //       sgst +
  //       igst
  //     );

  //   this.weightTotal =
  //     round(totalWeight);

  //   this.Taxable =
  //     round(taxableTotal);

  //   this.NonTaxableTotal =
  //     round(nonTaxableTotal);

  //   this.FinalTaxableAmt =
  //     round(finalTaxableAmt);

  //   this.CGSTtotal =
  //     isIGST
  //       ? 0
  //       : round(cgst);

  //   this.SGSTtotal =
  //     isIGST
  //       ? 0
  //       : round(sgst);

  //   this.IGSTtotal =
  //     isIGST
  //       ? round(igst)
  //       : 0;

  //   this.orderTotal =
  //     round(totalOrder);

  //   this.createOrderForm.patchValue({

  //     GSTOnFreight:
  //       round(freightGST),

  //     FinalTaxableAmt:
  //       this.FinalTaxableAmt

  //   });

  //   this.products =
  //     _.cloneDeep(this.products);

  //   return true;
  // }

  // async calculateOrderTotal() {

  //   const form = this.createOrderForm.value;

  //   const round = (num: number) =>
  //     Math.round((num + Number.EPSILON) * 100) / 100;

  //   const parseAmount = (val: any) =>
  //     parseFloat((val || 0).toString().replace(/[₹,]/g, ''));

  //   const supplyType = form.supplyType;

  //   const isExportSupply =
  //     supplyType === 'EXPORT' ||
  //     supplyType === 'SEZ';

  //   const isIGST =
  //     isExportSupply || this.isIGSTApplicable();

  //   const isLUT =
  //     form.isLUT &&
  //     (
  //       supplyType === 'EXPORT' ||
  //       supplyType === 'SEZ'
  //     );

  //   const isRCM = form.isRCM === true;

  //   let taxableTotal = 0;

  //   let nonTaxableTotal = 0;

  //   let cgstTotal = 0;

  //   let sgstTotal = 0;

  //   let igstTotal = 0;

  //   let totalQty = 0;

  //   // =========================================
  //   // Header Discount
  //   // =========================================

  //   const headerDiscount = parseAmount(
  //     this.createOrderForm.get('DiscountAmount')?.value
  //   );

  //   // =========================================
  //   // Calculate Gross Amount
  //   // =========================================

  //   let grossAmount = 0;

  //   for (const product of this.products) {

  //     const qty =
  //       Number(product.OrderQuantity) || 0;

  //     const price =
  //       Number(product.UnitPrice) || 0;

  //     grossAmount += qty * price;
  //   }

  //   // =========================================
  //   // Product Loop
  //   // =========================================

  //   for (const product of this.products) {

  //     const qty =
  //       Number(product.OrderQuantity) || 0;

  //     const unitPrice =
  //       Number(product.UnitPrice) || 0;

  //     const gstRate =
  //       Number(product.GSTRate) || 0;

  //     const lineDiscountPercent =
  //       Number(product.Discount) || 0;

  //     const amount = round(
  //       qty * unitPrice
  //     );

  //     // =========================================
  //     // Line Discount
  //     // =========================================

  //     const lineDiscountAmount = round(
  //       amount * lineDiscountPercent / 100
  //     );

  //     // =========================================
  //     // Header Discount Distribution
  //     // =========================================

  //     let headerDiscountShare = 0;

  //     if (grossAmount > 0) {

  //       headerDiscountShare = round(
  //         (amount / grossAmount) *
  //         headerDiscount
  //       );
  //     }

  //     // =========================================
  //     // Total Discount
  //     // =========================================

  //     const totalDiscount = round(
  //       lineDiscountAmount +
  //       headerDiscountShare
  //     );

  //     // =========================================
  //     // Net Amount
  //     // =========================================

  //     const netAmount = round(
  //       amount - totalDiscount
  //     );

  //     // const isTaxable =
  //     //   product.IsTaxable === true ||
  //     //   product.IsTaxable === 'Y';

  //     const isTaxable = !!product.IsTaxable;

  //     let cgst = 0;
  //     let sgst = 0;
  //     let igst = 0;

  //     if (
  //       isTaxable &&
  //       gstRate > 0 &&
  //       !isLUT &&
  //       !isRCM
  //     ) {

  //       const gstAmount = round(
  //         netAmount * gstRate / 100
  //       );

  //       if (isIGST) {

  //         igst = gstAmount;

  //       } else {

  //         cgst = round(gstAmount / 2);

  //         sgst = round(gstAmount / 2);
  //       }
  //     }

  //     const salesTax = round(
  //       cgst + sgst + igst
  //     );

  //     const lineTotal = round(
  //       netAmount + salesTax
  //     );

  //     // =========================================
  //     // Assign Values
  //     // =========================================

  //     product.ExtensionPrice = amount;

  //     product.Amount = amount;

  //     product.DiscountAmount = totalDiscount;

  //     product.NetAmount = netAmount;

  //     product.CGST = cgst;

  //     product.SGST = sgst;

  //     product.IGST = igst;

  //     product.SalesTax = salesTax;

  //     product.LineTotal = lineTotal;

  //     product.TaxableAmount = netAmount;

  //     // =========================================
  //     // Totals
  //     // =========================================

  //     if (isTaxable) {

  //       taxableTotal += netAmount;

  //     } else {

  //       nonTaxableTotal += netAmount;
  //     }

  //     cgstTotal += cgst;

  //     sgstTotal += sgst;

  //     igstTotal += igst;

  //     totalQty += qty;
  //   }

  //   // =========================================
  //   // Freight
  //   // =========================================

  //   const freight = parseAmount(
  //     this.createOrderForm.get('FreightTotal')?.value
  //   );

  //   const freightRate = parseAmount(
  //     this.createOrderForm.get('RateOnFreight')?.value
  //   );

  //   let freightGST = 0;

  //   if (
  //     freight > 0 &&
  //     freightRate > 0 &&
  //     !isLUT &&
  //     !isRCM
  //   ) {

  //     freightGST = round(
  //       freight * freightRate / 100
  //     );

  //     if (isIGST) {

  //       igstTotal += freightGST;

  //     } else {

  //       cgstTotal += round(freightGST / 2);

  //       sgstTotal += round(freightGST / 2);
  //     }
  //   }

  //   // =========================================
  //   // Final Taxable
  //   // =========================================

  //   const finalTaxableAmt = round(
  //     taxableTotal + freight
  //   );

  //   // =========================================
  //   // Final Order Total
  //   // =========================================

  //   const totalOrder = round(
  //     finalTaxableAmt +
  //     nonTaxableTotal +
  //     cgstTotal +
  //     sgstTotal +
  //     igstTotal
  //   );

  //   // =========================================
  //   // Assign Header Totals
  //   // =========================================

  //   this.weightTotal = round(totalQty);

  //   this.Taxable = round(taxableTotal);

  //   this.NonTaxableTotal = round(nonTaxableTotal);

  //   this.FinalTaxableAmt = round(finalTaxableAmt);

  //   this.CGSTtotal =
  //     isIGST
  //       ? 0
  //       : round(cgstTotal);

  //   this.SGSTtotal =
  //     isIGST
  //       ? 0
  //       : round(sgstTotal);

  //   this.IGSTtotal =
  //     isIGST
  //       ? round(igstTotal)
  //       : 0;

  //   this.orderTotal = round(totalOrder);

  //   this.createOrderForm.patchValue({
  //     GSTOnFreight: round(freightGST)
  //   });

  //   // =========================================
  //   // Refresh Grid
  //   // =========================================

  //   this.products = _.cloneDeep(this.products);

  //   return true;
  // }

  // async calculateOrderTotal() {

  //   const form = this.createOrderForm.value;

  //   // ==========================================
  //   // SUPPLY TYPE
  //   // ==========================================

  //   const supplyType = form.supplyType;

  //   const isExportSupply =
  //     supplyType === 'EXPORT' ||
  //     supplyType === 'SEZ';

  //   // EXPORT / SEZ => ALWAYS IGST
  //   const isIGST =
  //     isExportSupply || this.isIGSTApplicable();

  //   // LUT
  //   const isLUT =
  //     form.isLUT === true &&
  //     (
  //       supplyType === 'EXPORT' ||
  //       supplyType === 'SEZ'
  //     );

  //   // RCM
  //   const isRCM =
  //     form.isRCM === true;

  //   // ==========================================
  //   // TOTALS
  //   // ==========================================

  //   let totalQty = 0;

  //   let taxableTotal = 0;
  //   let nonTaxableTotal = 0;

  //   let cgst = 0;
  //   let sgst = 0;
  //   let igst = 0;

  //   // ==========================================
  //   // HELPERS
  //   // ==========================================

  //   const round = (num: number): number =>
  //     Math.round((num + Number.EPSILON) * 100) / 100;

  //   const parseAmount = (value: any): number =>
  //     parseFloat(
  //       (value || 0)
  //         .toString()
  //         .replace(/[₹,]/g, '')
  //     ) || 0;

  //   // ==========================================
  //   // PRODUCT LOOP
  //   // ==========================================

  //   for (const product of this.products) {

  //     // --------------------------------------
  //     // BASIC VALUES
  //     // --------------------------------------

  //     const qty =
  //       Number(product.OrderQuantity) || 0;

  //     const unitPrice =
  //       parseAmount(product.UnitPrice);

  //     const gstRate =
  //       Number(product.GSTRate) || 0;

  //     // 🔥 DISCOUNT IS DIRECT AMOUNT
  //     const discountAmount =
  //       parseAmount(product.Discount);

  //     totalQty += qty;

  //     // --------------------------------------
  //     // AMOUNT = QTY × PRICE
  //     // GST SHOULD NOT BE INCLUDED
  //     // --------------------------------------

  //     const amount = round(
  //       qty * unitPrice
  //     );

  //     // --------------------------------------
  //     // VALIDATE DISCOUNT
  //     // --------------------------------------

  //     const validDiscount =
  //       discountAmount > amount
  //         ? amount
  //         : discountAmount;

  //     // --------------------------------------
  //     // NET AMOUNT
  //     // --------------------------------------

  //     const netAmount = round(
  //       amount - validDiscount
  //     );

  //     // --------------------------------------
  //     // TAXABLE CHECK
  //     // --------------------------------------

  //     const isTaxable =
  //       (typeof product.IsTaxable === 'boolean' &&
  //         product.IsTaxable === true) ||

  //       (typeof product.IsTaxable === 'string' &&
  //         product.IsTaxable === 'Y');

  //     // --------------------------------------
  //     // GST CALCULATION
  //     // --------------------------------------

  //     let productCGST = 0;
  //     let productSGST = 0;
  //     let productIGST = 0;

  //     if (isTaxable) {

  //       taxableTotal += netAmount;

  //       // GST only if NOT LUT and NOT RCM
  //       if (
  //         gstRate > 0 &&
  //         !isLUT &&
  //         !isRCM
  //       ) {

  //         const gstAmount = round(
  //           netAmount * gstRate / 100
  //         );

  //         // IGST
  //         if (isIGST) {

  //           productIGST = gstAmount;

  //           igst += gstAmount;

  //         } else {

  //           // CGST + SGST
  //           productCGST = round(gstAmount / 2);
  //           productSGST = round(gstAmount / 2);

  //           cgst += productCGST;
  //           sgst += productSGST;
  //         }
  //       }

  //     } else {

  //       nonTaxableTotal += netAmount;
  //     }

  //     // --------------------------------------
  //     // FINAL LINE TOTAL
  //     // --------------------------------------

  //     const salesTax =
  //       round(
  //         productCGST +
  //         productSGST +
  //         productIGST
  //       );

  //     const lineTotal =
  //       round(
  //         netAmount + salesTax
  //       );

  //     // ======================================
  //     // UPDATE PRODUCT
  //     // ======================================

  //     // 🔥 Qty × Price only
  //     product.Amount = amount;

  //     // 🔥 WITHOUT GST
  //     product.ExtensionPrice = amount;

  //     product.DiscountAmount = validDiscount;

  //     product.NetAmount = netAmount;

  //     product.CGST = round(productCGST);
  //     product.SGST = round(productSGST);
  //     product.IGST = round(productIGST);

  //     product.SalesTax = salesTax;

  //     // 🔥 WITH GST
  //     product.LineTotal = lineTotal;
  //   }

  //   // ==========================================
  //   // FREIGHT
  //   // ==========================================

  //   const freight =
  //     parseAmount(
  //       this.createOrderForm.get('FreightTotal')?.value
  //     );

  //   const freightRate =
  //     parseAmount(
  //       this.createOrderForm.get('RateOnFreight')?.value
  //     );

  //   let freightGST = 0;

  //   if (
  //     freight > 0 &&
  //     freightRate > 0 &&
  //     !isLUT &&
  //     !isRCM
  //   ) {

  //     freightGST = round(
  //       freight * freightRate / 100
  //     );

  //     if (isIGST) {

  //       igst += freightGST;

  //     } else {

  //       cgst += round(freightGST / 2);
  //       sgst += round(freightGST / 2);
  //     }
  //   }

  //   // ==========================================
  //   // HEADER DISCOUNT
  //   // ==========================================

  //   const headerDiscount =
  //     parseAmount(
  //       this.createOrderForm.get('DiscountAmount')?.value
  //     );

  //   // ==========================================
  //   // FINAL TAXABLE
  //   // ==========================================

  //   const finalTaxableAmt =
  //     round(
  //       taxableTotal +
  //       freight -
  //       headerDiscount
  //     );

  //   // ==========================================
  //   // ORDER TOTAL
  //   // ==========================================

  //   const orderTotal =
  //     round(
  //       finalTaxableAmt +
  //       nonTaxableTotal +
  //       cgst +
  //       sgst +
  //       igst
  //     );

  //   // ==========================================
  //   // UPDATE SCREEN TOTALS
  //   // ==========================================

  //   this.weightTotal =
  //     round(totalQty);

  //   this.Taxable =
  //     round(taxableTotal);

  //   this.NonTaxableTotal =
  //     round(nonTaxableTotal);

  //   this.FinalTaxableAmt =
  //     round(finalTaxableAmt);

  //   this.CGSTtotal =
  //     isIGST
  //       ? 0
  //       : round(cgst);

  //   this.SGSTtotal =
  //     isIGST
  //       ? 0
  //       : round(sgst);

  //   this.IGSTtotal =
  //     isIGST
  //       ? round(igst)
  //       : 0;

  //   this.orderTotal =
  //     round(orderTotal);

  //   // ==========================================
  //   // UPDATE FORM
  //   // ==========================================

  //   this.createOrderForm.patchValue({

  //     GSTOnFreight: round(freightGST),

  //     FinalTaxableAmt:
  //       this.FinalTaxableAmt

  //   });

  //   // ==========================================
  //   // REFRESH GRID
  //   // ==========================================

  //   this.products = _.cloneDeep(this.products);

  //   return true;
  // }

  // async calculateOrderTotal() {

  //   // =========================================
  //   // USE isIGSTApplicable()
  //   // =========================================

  //   this.isIGST = this.isIGSTApplicable();

  //   let totalWeight = 0;
  //   let taxableTotal = 0;

  //   let cgst = 0;
  //   let sgst = 0;
  //   let igst = 0;

  //   const getNum = (val: any) =>
  //     _.toNumber(val) || 0;

  //   const parseCurrency = (val: any) =>
  //     parseFloat(
  //       (val ?? 0)
  //         .toString()
  //         .replace(/[₹,]/g, '')
  //     ) || 0;

  //   // =========================================
  //   // TOTAL BEFORE HEADER DISCOUNT
  //   // =========================================

  //   let totalBeforeHeaderDiscount = 0;

  //   for (const p of this.products) {

  //     const qty =
  //       getNum(p.OrderQuantity);

  //     const weight =
  //       getNum(p.Weight) ||
  //       getNum(p.ShipedWeight);

  //     const unitPrice =
  //       parseCurrency(p.UnitPrice);

  //     const lineDiscount =
  //       getNum(p.Discount);

  //     const productData =
  //       await this.getProductById(
  //         Number(p.ProductId)
  //       );

  //     const costType =
  //       productData?.costCalculation || 'Qty';

  //     const amount =
  //       _.round(
  //         costType === 'Qty'
  //           ? qty * unitPrice
  //           : weight * unitPrice,
  //         2
  //       );

  //     // =========================================
  //     // AMOUNT = QTY × PRICE ONLY
  //     // =========================================

  //     p.Amount = amount;

  //     p.ExtensionPrice = amount;

  //     p.DiscountAmount = lineDiscount;

  //     totalBeforeHeaderDiscount +=
  //       _.round(amount - lineDiscount, 2);
  //   }

  //   // =========================================
  //   // HEADER DISCOUNT ENABLE/DISABLE
  //   // =========================================

  //   const hasLineDiscount =
  //     this.products.some(
  //       x => getNum(x.Discount) > 0
  //     );

  //   const discountControl =
  //     this.createOrderForm.get('DiscountAmount');

  //   if (hasLineDiscount) {

  //     if (discountControl?.enabled) {

  //       discountControl.setValue(
  //         0,
  //         { emitEvent: false }
  //       );

  //       discountControl.disable({
  //         emitEvent: false
  //       });
  //     }

  //   } else {

  //     if (discountControl?.disabled) {

  //       discountControl.enable({
  //         emitEvent: false
  //       });
  //     }
  //   }

  //   const headerDiscount =
  //     hasLineDiscount
  //       ? 0
  //       : getNum(discountControl?.value);

  //   // =========================================
  //   // ITEM CALCULATIONS
  //   // =========================================

  //   for (const product of this.products) {

  //     const qty =
  //       getNum(product.OrderQuantity);

  //     const amount =
  //       getNum(product.Amount);

  //     const lineDiscount =
  //       getNum(product.Discount);

  //     const afterLineDiscount =
  //       _.round(amount - lineDiscount, 2);

  //     const headerDiscountShare =
  //       totalBeforeHeaderDiscount > 0
  //         && headerDiscount > 0
  //         ? _.round(
  //           (
  //             afterLineDiscount /
  //             totalBeforeHeaderDiscount
  //           ) * headerDiscount,
  //           2
  //         )
  //         : 0;

  //     const netAmount =
  //       _.round(
  //         afterLineDiscount -
  //         headerDiscountShare,
  //         2
  //       );

  //     product.NetAmount = netAmount;

  //     product.DiscountAmount =
  //       _.round(
  //         lineDiscount +
  //         headerDiscountShare,
  //         2
  //       );

  //     taxableTotal += netAmount;

  //     // =========================================
  //     // TAXABLE CHECK
  //     // =========================================

  //     const isTaxable =
  //       product.IsTaxable === true;

  //     const gstRate =
  //       getNum(product.GSTRate);

  //     let taxAmount = 0;

  //     if (isTaxable && gstRate > 0) {

  //       taxAmount =
  //         _.round(
  //           (netAmount * gstRate) / 100,
  //           2
  //         );

  //       if (this.isIGST) {

  //         product.IGST = taxAmount;
  //         product.CGST = 0;
  //         product.SGST = 0;

  //         igst += taxAmount;

  //       } else {

  //         product.CGST =
  //           _.round(taxAmount / 2, 2);

  //         product.SGST =
  //           _.round(taxAmount / 2, 2);

  //         product.IGST = 0;

  //         cgst += product.CGST;
  //         sgst += product.SGST;
  //       }

  //     } else {

  //       product.CGST = 0;
  //       product.SGST = 0;
  //       product.IGST = 0;
  //     }

  //     product.SalesTax =
  //       _.round(
  //         product.CGST +
  //         product.SGST +
  //         product.IGST,
  //         2
  //       );

  //     // =========================================
  //     // LINE TOTAL
  //     // =========================================

  //     product.LineTotal =
  //       _.round(
  //         netAmount +
  //         product.SalesTax,
  //         2
  //       );

  //     totalWeight += qty;
  //   }

  //   // =========================================
  //   // FREIGHT GST
  //   // =========================================

  //   const freightTotal =
  //     _.round(
  //       getNum(
  //         this.createOrderForm
  //           .get('FreightTotal')
  //           ?.value
  //       ),
  //       2
  //     );

  //   const freightRate =
  //     _.round(
  //       getNum(
  //         this.createOrderForm
  //           .get('RateOnFreight')
  //           ?.value
  //       ),
  //       2
  //     );

  //   let freightGST = 0;

  //   if (freightTotal > 0 && freightRate > 0) {

  //     freightGST =
  //       _.round(
  //         (freightTotal * freightRate) / 100,
  //         2
  //       );

  //     if (this.isIGST) {

  //       igst += freightGST;

  //     } else {

  //       cgst += _.round(freightGST / 2, 2);
  //       sgst += _.round(freightGST / 2, 2);
  //     }
  //   }

  //   // =========================================
  //   // FINAL TOTALS
  //   // =========================================

  //   const finalTaxableAmt =
  //     _.round(
  //       taxableTotal + freightTotal,
  //       2
  //     );

  //   const totalOrder =
  //     _.round(
  //       finalTaxableAmt +
  //       cgst +
  //       sgst +
  //       igst,
  //       2
  //     );

  //   this.weightTotal =
  //     _.round(totalWeight, 2);

  //   this.Taxable =
  //     _.round(taxableTotal, 2);

  //   this.FinalTaxableAmt =
  //     _.round(finalTaxableAmt, 2);

  //   this.CGSTtotal =
  //     this.isIGST
  //       ? 0
  //       : _.round(cgst, 2);

  //   this.SGSTtotal =
  //     this.isIGST
  //       ? 0
  //       : _.round(sgst, 2);

  //   this.IGSTtotal =
  //     this.isIGST
  //       ? _.round(igst, 2)
  //       : 0;

  //   this.orderTotal =
  //     _.round(totalOrder, 2);

  //   // =========================================
  //   // UI REFRESH
  //   // =========================================

  //   this.products =
  //     _.cloneDeep(this.products);

  //   return true;
  // }

  async calculateOrderTotal() {

    // =========================================
    // FORM VALUES
    // =========================================

    const form = this.createOrderForm.value;

    this.isIGST = this.isIGSTApplicable();

    const isLUT =
      form.isLUT === true &&
      (
        form.supplyType === 'EXPORT' ||
        form.supplyType === 'SEZ'
      );

    const isRCM =
      form.isRCM === true;

    let totalWeight = 0;
    let taxableTotal = 0;
    let nonTaxableTotal = 0;

    let cgst = 0;
    let sgst = 0;
    let igst = 0;

    const getNum = (val: any) =>
      _.toNumber(val) || 0;

    const parseCurrency = (val: any) =>
      parseFloat(
        (val ?? 0)
          .toString()
          .replace(/[₹,]/g, '')
      ) || 0;

    // =========================================
    // PRODUCT CACHE
    // =========================================

    const productCache = new Map<number, any>();

    const getProduct = async (productId: number) => {

      if (!productCache.has(productId)) {

        const data =
          await this.getProductById(productId);

        productCache.set(productId, data);
      }

      return productCache.get(productId);
    };

    // =========================================
    // TOTAL BEFORE HEADER DISCOUNT
    // =========================================

    let totalBeforeHeaderDiscount = 0;

    for (const p of this.products) {

      const qty =
        getNum(p.OrderQuantity);

      const weight =
        getNum(p.Weight) ||
        getNum(p.ShipedWeight);

      const unitPrice =
        parseCurrency(p.UnitPrice);

      const lineDiscountPercent =
        getNum(p.Discount);

      const productData =
        await getProduct(
          Number(p.ProductId)
        );

      const costType =
        productData?.costCalculation || 'Qty';

      const amount =
        _.round(
          costType === 'Qty'
            ? qty * unitPrice
            : weight * unitPrice,
          2
        );

      // =========================================
      // AMOUNT = QTY × PRICE ONLY
      // =========================================

      p.Amount = amount;

      p.ExtensionPrice = amount;

      // Calculate discount amount as percentage of amount using utility function
      const lineDiscountAmount = discountAmountFromPercent(amount, lineDiscountPercent);

      p.DiscountAmount = lineDiscountAmount;

      totalBeforeHeaderDiscount +=
        _.round(
          amount - lineDiscountAmount,
          2
        );
    }

    // =========================================
    // HEADER DISCOUNT ENABLE / DISABLE
    // =========================================

    const hasLineDiscount =
      this.products.some(
        x => getNum(x.Discount) > 0
      );

    const discountControl =
      this.createOrderForm.get(
        'DiscountAmount'
      );

    if (hasLineDiscount) {

      if (discountControl?.enabled) {

        discountControl.setValue(
          0,
          { emitEvent: false }
        );

        discountControl.disable({
          emitEvent: false
        });
      }

    } else {

      if (discountControl?.disabled) {

        discountControl.enable({
          emitEvent: false
        });
      }
    }

    const headerDiscount =
      hasLineDiscount
        ? 0
        : getNum(discountControl?.value);

    // =========================================
    // ITEM CALCULATION
    // =========================================

    for (const product of this.products) {

      const qty =
        getNum(product.OrderQuantity);

      const weight =
        getNum(product.Weight) ||
        getNum(product.ShipedWeight);

      const amount =
        getNum(product.Amount);

      const lineDiscountPercent =
        getNum(product.Discount);

      // Calculate discount amount as percentage of amount using utility function
      const lineDiscountAmount = discountAmountFromPercent(amount, lineDiscountPercent);

      const afterLineDiscount =
        _.round(
          amount - lineDiscountAmount,
          2
        );

      // Header discount only affects summary, not line calculations
      const netAmount = afterLineDiscount;

      product.NetAmount =
        netAmount;

      product.DiscountAmount = lineDiscountAmount;

      // =========================================
      // TAXABLE CHECK
      // =========================================

      // const isTaxable =
      //   product.IsTaxable === true ||
      //   product.IsTaxable === 'Y';

      const isTaxable =
        (typeof product.IsTaxable === 'string' && product.IsTaxable === 'Y') ||
        (typeof product.IsTaxable === 'boolean' && product.IsTaxable === true);

      const gstRate =
        getNum(product.GSTRate);

      let taxAmount = 0;

      if (isTaxable) {

        taxableTotal += netAmount;

        // =========================================
        // GST CALCULATION
        // LUT => GST = 0
        // RCM => GST = 0
        // =========================================

        if (
          gstRate > 0 &&
          !isLUT &&
          !isRCM
        ) {

          taxAmount =
            _.round(
              (netAmount * gstRate) / 100,
              2
            );

          // =========================================
          // IGST
          // =========================================

          if (this.isIGST) {

            product.IGST =
              taxAmount;

            product.CGST = 0;
            product.SGST = 0;

            igst += taxAmount;

          } else {

            // =========================================
            // CGST + SGST
            // =========================================

            product.CGST =
              _.round(
                taxAmount / 2,
                2
              );

            product.SGST =
              _.round(
                taxAmount / 2,
                2
              );

            product.IGST = 0;

            cgst += product.CGST;
            sgst += product.SGST;
          }

        } else {

          // =========================================
          // LUT / RCM
          // =========================================

          product.CGST = 0;
          product.SGST = 0;
          product.IGST = 0;
        }

      } else {

        nonTaxableTotal += netAmount;

        product.CGST = 0;
        product.SGST = 0;
        product.IGST = 0;
      }

      // =========================================
      // SALES TAX
      // =========================================

      product.SalesTax =
        _.round(
          product.CGST +
          product.SGST +
          product.IGST,
          2
        );

      // =========================================
      // LINE TOTAL
      // =========================================

      product.LineTotal =
        _.round(
          netAmount +
          product.SalesTax,
          2
        );

      // =========================================
      // TAXABLE AMOUNT
      // =========================================

      product.TaxableAmount =
        _.round(netAmount, 2);

      totalWeight +=
        weight > 0
          ? weight
          : qty;
    }

    // =========================================
    // FREIGHT
    // =========================================

    const freightTotal =
      _.round(
        getNum(
          this.createOrderForm
            .get('FreightTotal')
            ?.value
        ),
        2
      );

    const freightRate =
      _.round(
        getNum(
          this.createOrderForm
            .get('RateOnFreight')
            ?.value
        ),
        2
      );

    let freightGST = 0;

    if (
      freightTotal > 0 &&
      freightRate > 0 &&
      !isLUT &&
      !isRCM
    ) {

      freightGST =
        _.round(
          (freightTotal * freightRate) / 100,
          2
        );

      if (this.isIGST) {

        igst += freightGST;

      } else {

        cgst += _.round(
          freightGST / 2,
          2
        );

        sgst += _.round(
          freightGST / 2,
          2
        );
      }
    }

    // =========================================
    // VALIDATE HEADER DISCOUNT
    // =========================================

    const maxDiscount =
      _.round(
        totalBeforeHeaderDiscount +
        freightTotal,
        2
      );

    if (
      !hasLineDiscount &&
      headerDiscount > maxDiscount &&
      maxDiscount > 0
    ) {

      if (
        discountControl?.dirty &&
        !discountControl?.hasError(
          'exceedTotal'
        )
      ) {

        this.messageService.clear();

        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Discount',
          detail:
            'Discount cannot be greater than order total.'
        });
      }

      discountControl?.setErrors({
        exceedTotal: true
      });

    } else {

      if (
        discountControl?.hasError(
          'exceedTotal'
        )
      ) {

        discountControl.setErrors(null);
      }
    }

    // =========================================
    // FINAL TOTALS
    // =========================================

    const finalTaxableAmt =
      _.round(
        taxableTotal +
        freightTotal -
        headerDiscount,
        2
      );

    const totalOrder =
      _.round(
        finalTaxableAmt +
        nonTaxableTotal +
        cgst +
        sgst +
        igst,
        2
      );

    this.weightTotal =
      _.round(totalWeight, 2);

    this.Taxable =
      _.round(taxableTotal, 2);

    this.NonTaxableTotal =
      _.round(nonTaxableTotal, 2);

    this.FinalTaxableAmt =
      _.round(finalTaxableAmt, 2);

    this.CGSTtotal =
      this.isIGST
        ? 0
        : _.round(cgst, 2);

    this.SGSTtotal =
      this.isIGST
        ? 0
        : _.round(sgst, 2);

    this.IGSTtotal =
      this.isIGST
        ? _.round(igst, 2)
        : 0;

    this.orderTotal =
      _.round(totalOrder, 2);

    // =========================================
    // UI REFRESH
    // =========================================

    this.products =
      _.cloneDeep(this.products);

    return true;
  }

  // async calculateOrderTotal() {

  //   const form = this.createOrderForm.value;

  //   const isIGST = this.isIGSTApplicable();

  //   const isLUT =
  //     form.isLUT &&
  //     (form.supplyType === 'EXPORT' || form.supplyType === 'SEZ');

  //   const isRCM = form.isRCM === true;

  //   let totalWeight = 0;
  //   let taxableTotal = 0;
  //   let nonTaxableTotal = 0;

  //   let cgst = 0;
  //   let sgst = 0;
  //   let igst = 0;

  //   const parseAmount = (val: any) =>
  //     parseFloat((val || 0).toString().replace(/[₹,]/g, ''));

  //   const round = (num: number) =>
  //     Math.round((num + Number.EPSILON) * 100) / 100;

  //   // 🔥 Product cache (avoid multiple API calls)
  //   const productCache = new Map<number, any>();

  //   const getProduct = async (productId: number) => {
  //     if (!productCache.has(productId)) {
  //       const data = await this.getProductById(productId);
  //       productCache.set(productId, data);
  //     }
  //     return productCache.get(productId);
  //   };

  //   for (const product of this.products) {

  //     const qty = Number(product.OrderQuantity) || 0;
  //     const weight = Number(product.Weight) || 0;
  //     const unitPrice = parseAmount(product.UnitPrice);

  //     const productData = await getProduct(Number(product.ProductId));
  //     const costType = productData?.costCalculation || 'Qty';

  //     let lineAmount = costType === 'Qty'
  //       ? qty * unitPrice
  //       : weight * unitPrice;

  //     // 🔹 Discount per line
  //     const discountRate = Number(product.Discount) || 0;
  //     lineAmount -= lineAmount * (discountRate / 100);

  //     lineAmount = round(lineAmount);

  //     // const isTaxable =
  //     //   product.IsTaxable === true || product.IsTaxable === 'Y';

  //     const isTaxable =
  //       (typeof product.IsTaxable === 'string' && product.IsTaxable === 'Y') ||
  //       (typeof product.IsTaxable === 'boolean' && product.IsTaxable === true);

  //     let productCGST = 0;
  //     let productSGST = 0;
  //     let productIGST = 0;

  //     if (isTaxable) {

  //       taxableTotal += lineAmount;

  //       const gstRate = Number(product.GSTRate) || 0;

  //       if (gstRate > 0 && !isLUT && !isRCM) {

  //         // ✅ CRITICAL: round BEFORE split
  //         const gstAmount = round(lineAmount * gstRate / 100);

  //         if (isIGST) {
  //           productIGST = gstAmount;
  //           igst += gstAmount;
  //         } else {
  //           productCGST = round(gstAmount / 2);
  //           productSGST = round(gstAmount / 2);

  //           cgst += productCGST;
  //           sgst += productSGST;
  //         }
  //       }

  //     } else {
  //       nonTaxableTotal += lineAmount;
  //     }

  //     // 🔥 Update product values
  //     product.CGST = round(productCGST);
  //     product.SGST = round(productSGST);
  //     product.IGST = round(productIGST);

  //     product.TaxableAmount = round(lineAmount);
  //     product.SalesTax = round(product.CGST + product.SGST + product.IGST);
  //     product.ExtensionPrice = round(lineAmount + product.SalesTax);

  //     totalWeight += costType === 'Qty' ? qty : weight;
  //   }

  //   // 🔹 Freight
  //   const freight = parseAmount(this.createOrderForm.get('FreightTotal')?.value);
  //   const freightRate = parseAmount(this.createOrderForm.get('RateOnFreight')?.value);

  //   let freightGST = round(freight * (freightRate / 100));

  //   if (freightGST > 0 && !isLUT && !isRCM) {

  //     if (isIGST) {
  //       igst += freightGST;
  //     } else {
  //       cgst += round(freightGST / 2);
  //       sgst += round(freightGST / 2);
  //     }
  //   }

  //   // 🔹 Discount (header level)
  //   const discountControl = this.createOrderForm.get('DiscountAmount');
  //   const discount = parseAmount(discountControl?.value);

  //   const maxDiscount =
  //     taxableTotal + nonTaxableTotal + freight + cgst + sgst + igst;

  //   if (discount > maxDiscount && maxDiscount > 0) {

  //     if (discountControl?.dirty && !discountControl?.hasError('exceedTotal')) {
  //       this.messageService.clear();
  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Invalid Discount',
  //         detail: 'Discount cannot be greater than order total.'
  //       });
  //     }

  //     discountControl?.setErrors({ exceedTotal: true });

  //   } else {
  //     discountControl?.setErrors(null);
  //   }

  //   // 🔹 Final Calculation
  //   const finalTaxableAmt =
  //     taxableTotal + freight - (discount > maxDiscount ? 0 : discount);

  //   const totalOrder =
  //     finalTaxableAmt + nonTaxableTotal + cgst + sgst + igst;

  //   // 🔥 Assign totals
  //   this.weightTotal = round(totalWeight);
  //   this.Taxable = round(taxableTotal);
  //   this.NonTaxableTotal = round(nonTaxableTotal);
  //   this.FinalTaxableAmt = round(finalTaxableAmt);

  //   this.CGSTtotal = isIGST ? 0 : round(cgst);
  //   this.SGSTtotal = isIGST ? 0 : round(sgst);
  //   this.IGSTtotal = isIGST ? round(igst) : 0;

  //   this.orderTotal = round(totalOrder);

  //   // 🔥 Refresh UI
  //   this.products = _.cloneDeep(this.products);

  //   return true;
  // }


  calculateGST(price: number, quantity: number, gstrate: number, taxable: boolean): number {
    if (taxable === true) {
      const gst = (price * quantity) * gstrate / 100;
      return gst;
    }
    else {
      return 0;
    }
  }

  // async onProductEdit(event: any) {
  //   let editData = event;

  //   for (const product of this.products) {
  //     // let productData;
  //     // try {
  //     //   productData = await this.getProductById(product.ProductId);
  //     // } catch (error) {
  //     //   console.error('Error fetching product data:', error);
  //     //   this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch product data.' });
  //     //   this.loader = false;
  //     //   return;
  //     // }

  //     const costCalculationType = 'Qty';

  //     if (costCalculationType === 'Qty' && product.OrderQuantity <= 0) {
  //       this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'OrderQuantity must be greater than 0.' });
  //       this.loader = false;
  //       return;
  //     }

  //   }


  //   const costCalculationType = 'Qty';
  //   if (costCalculationType === 'Qty') {
  //     editData.ExtensionPrice = editData.UnitPrice * editData.OrderQuantity;
  //     editData.SalesTax = this.calculateGST(editData.UnitPrice, editData.OrderQuantity, editData.GSTRate, editData.IsTaxable);
  //   } else if (costCalculationType === 'Wgt') {
  //     editData.ExtensionPrice = editData.UnitPrice * editData.ShipedWeight;
  //     editData.SalesTax = this.calculateGST(editData.UnitPrice, editData.ShipedWeight, editData.GSTRate, editData.IsTaxable);
  //   }

  //   editData.CGST = (!this.isIGST) ? editData.SalesTax / 2 : 0;
  //   editData.SGST = (!this.isIGST) ? editData.SalesTax / 2 : 0;
  //   editData.IGST = (this.isIGST) ? editData.SalesTax : 0;

  //   editData.UnitPrice = parseFloat(editData.UnitPrice).toFixed(2);
  //   editData.Discount = editData.Discount || 0;
  //   editData.DiscountAmount = editData.DiscountAmount || 0;
  //   editData.NetAmount = _.round(editData.ExtensionPrice - editData.Discount, 2);
  //   editData.LineTotal = _.round(editData.NetAmount + editData.SalesTax, 2);

  //   if (!this.isEdit) {
  //     const index = this.products.findIndex(product => product.SalesOrderLineItemId === editData.SalesOrderLineItemId);
  //     if (index !== -1) {
  //       this.updateSalesOrderLineItems(editData, index);
  //     } else {
  //       console.error('Product not found', editData);
  //       this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while updating product' });
  //     }
  //   } else {
  //     const index = this.products.findIndex(product => product.LineItemNumber === editData.LineItemNumber);
  //     if (index !== -1) {
  //       this.products[index] = {
  //         ...editData,
  //         ExtensionPrice: editData.ExtensionPrice,
  //         CGST: editData.CGST,
  //         SGST: editData.SGST,
  //         IGST: editData.IGST,
  //         SalesTax: editData.SalesTax,
  //         UnitPrice: editData.UnitPrice,
  //       };
  //       this.calculateOrderTotal();
  //     }
  //   }
  // }

  // async onProductEdit(product: any) {

  //   const round = (num: number) =>
  //     Math.round((num + Number.EPSILON) * 100) / 100;

  //   const qty = Number(product.OrderQuantity) || 0;

  //   const unitPrice = Number(product.UnitPrice) || 0;

  //   const gstRate = Number(product.GSTRate) || 0;

  //   const discountPercent = Number(product.Discount) || 0;

  //   const form = this.createOrderForm.value;

  //   const supplyType = form.supplyType;

  //   const isExportSupply =
  //     supplyType === 'EXPORT' ||
  //     supplyType === 'SEZ';

  //   const isIGST =
  //     isExportSupply || this.isIGSTApplicable();

  //   const isLUT =
  //     form.isLUT &&
  //     (
  //       supplyType === 'EXPORT' ||
  //       supplyType === 'SEZ'
  //     );

  //   const isRCM = form.isRCM === true;

  //   // =========================================
  //   // Amount
  //   // =========================================

  //   const amount = round(qty * unitPrice);

  //   // =========================================
  //   // Discount
  //   // =========================================

  //   const discountAmount = round(
  //     amount * discountPercent / 100
  //   );

  //   // =========================================
  //   // Net Amount
  //   // =========================================

  //   const netAmount = round(
  //     amount - discountAmount
  //   );

  //   // =========================================
  //   // GST
  //   // =========================================

  //   let cgst = 0;
  //   let sgst = 0;
  //   let igst = 0;

  //   const isTaxable =
  //     product.IsTaxable === true ||
  //     product.IsTaxable === 'Y';

  //   if (
  //     isTaxable &&
  //     gstRate > 0 &&
  //     !isLUT &&
  //     !isRCM
  //   ) {

  //     const gstAmount = round(
  //       netAmount * gstRate / 100
  //     );

  //     if (isIGST) {

  //       igst = gstAmount;

  //     } else {

  //       cgst = round(gstAmount / 2);

  //       sgst = round(gstAmount / 2);
  //     }
  //   }

  //   const salesTax = round(
  //     cgst + sgst + igst
  //   );

  //   // =========================================
  //   // Final Line Total
  //   // =========================================

  //   const lineTotal = round(
  //     netAmount + salesTax
  //   );

  //   // =========================================
  //   // Assign Values
  //   // =========================================

  //   product.ExtensionPrice = amount;

  //   product.Amount = amount;

  //   product.DiscountAmount = discountAmount;

  //   product.NetAmount = netAmount;

  //   product.CGST = cgst;

  //   product.SGST = sgst;

  //   product.IGST = igst;

  //   product.SalesTax = salesTax;

  //   product.LineTotal = lineTotal;

  //   product.TaxableAmount = netAmount;

  //   // =========================================
  //   // Refresh Total
  //   // =========================================

  //   await this.calculateOrderTotal();
  // }

  // async onProductEdit(event: any) {

  //   const editData = event;

  //   // ==========================================
  //   // VALIDATION
  //   // ==========================================

  //   for (const product of this.products) {

  //     const costCalculationType = 'Qty';

  //     if (
  //       costCalculationType === 'Qty' &&
  //       (Number(product.OrderQuantity) || 0) <= 0
  //     ) {

  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Invalid Value',
  //         detail: 'Order Quantity must be greater than 0.'
  //       });

  //       return;
  //     }
  //   }

  //   // ==========================================
  //   // BASIC VALUES
  //   // ==========================================

  //   const qty =
  //     Number(editData.OrderQuantity) || 0;

  //   const shippedWeight =
  //     Number(editData.ShipedWeight) || 0;

  //   const unitPrice =
  //     Number(editData.UnitPrice) || 0;

  //   const gstRate =
  //     Number(editData.GSTRate) || 0;

  //   // 🔥 DISCOUNT IS DIRECT AMOUNT
  //   const discountAmount =
  //     Number(editData.Discount) || 0;

  //   const costCalculationType = 'Qty';

  //   // ==========================================
  //   // AMOUNT = QTY × PRICE
  //   // GST SHOULD NOT BE INCLUDED
  //   // ==========================================

  //   let amount = 0;

  //   if (costCalculationType === 'Qty') {

  //     amount = _.round(
  //       qty * unitPrice,
  //       2
  //     );

  //   } else {

  //     amount = _.round(
  //       shippedWeight * unitPrice,
  //       2
  //     );
  //   }

  //   // ==========================================
  //   // DISCOUNT VALIDATION
  //   // ==========================================

  //   if (discountAmount > amount) {

  //     this.messageService.add({
  //       severity: 'error',
  //       summary: 'Invalid Discount',
  //       detail: 'Discount cannot exceed amount.'
  //     });

  //     return;
  //   }

  //   // ==========================================
  //   // NET AMOUNT
  //   // ==========================================

  //   const netAmount = _.round(
  //     amount - discountAmount,
  //     2
  //   );

  //   // ==========================================
  //   // TAXABLE CHECK
  //   // ==========================================

  //   const isTaxable =
  //     (typeof editData.IsTaxable === 'boolean' &&
  //       editData.IsTaxable === true) ||

  //     (typeof editData.IsTaxable === 'string' &&
  //       editData.IsTaxable === 'Y');

  //   // ==========================================
  //   // GST CALCULATION
  //   // ==========================================

  //   let salesTax = 0;
  //   let cgst = 0;
  //   let sgst = 0;
  //   let igst = 0;

  //   const form = this.createOrderForm.value;

  //   const supplyType = form.supplyType;

  //   const isExportSupply =
  //     supplyType === 'EXPORT' ||
  //     supplyType === 'SEZ';

  //   const isIGST =
  //     isExportSupply || this.isIGSTApplicable();

  //   const isLUT =
  //     form.isLUT &&
  //     (
  //       supplyType === 'EXPORT' ||
  //       supplyType === 'SEZ'
  //     );

  //   const isRCM =
  //     form.isRCM === true;

  //   // ==========================================
  //   // GST ONLY WHEN:
  //   // 1. TAXABLE
  //   // 2. GST RATE > 0
  //   // 3. NOT LUT
  //   // 4. NOT RCM
  //   // ==========================================

  //   if (
  //     isTaxable &&
  //     gstRate > 0 &&
  //     !isLUT &&
  //     !isRCM
  //   ) {

  //     salesTax = _.round(
  //       netAmount * gstRate / 100,
  //       2
  //     );

  //     if (isIGST) {

  //       igst = salesTax;

  //     } else {

  //       cgst = _.round(salesTax / 2, 2);
  //       sgst = _.round(salesTax / 2, 2);
  //     }
  //   }

  //   // ==========================================
  //   // FINAL LINE TOTAL
  //   // ==========================================

  //   const lineTotal = _.round(
  //     netAmount + salesTax,
  //     2
  //   );

  //   // ==========================================
  //   // UPDATE OBJECT
  //   // ==========================================

  //   editData.UnitPrice = _.round(unitPrice, 2);

  //   // 🔥 Amount only
  //   editData.Amount = amount;

  //   // 🔥 ExtensionPrice should NOT include GST
  //   editData.ExtensionPrice = amount;

  //   // 🔥 Discount amount
  //   editData.Discount = discountAmount;
  //   editData.DiscountAmount = discountAmount;

  //   editData.NetAmount = netAmount;

  //   editData.CGST = cgst;
  //   editData.SGST = sgst;
  //   editData.IGST = igst;

  //   editData.SalesTax = salesTax;

  //   // 🔥 Final amount including GST
  //   editData.LineTotal = lineTotal;

  //   // ==========================================
  //   // UPDATE GRID
  //   // ==========================================

  //   if (!this.isEdit) {

  //     const index =
  //       this.products.findIndex(
  //         product =>
  //           product.SalesOrderLineItemId ===
  //           editData.SalesOrderLineItemId
  //       );

  //     if (index !== -1) {

  //       this.updateSalesOrderLineItems(
  //         editData,
  //         index
  //       );

  //     } else {

  //       console.error(
  //         'Product not found',
  //         editData
  //       );

  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Warning',
  //         detail: 'Error while updating product'
  //       });
  //     }

  //   } else {

  //     const index =
  //       this.products.findIndex(
  //         product =>
  //           product.LineItemNumber ===
  //           editData.LineItemNumber
  //       );

  //     if (index !== -1) {

  //       this.products[index] = {
  //         ...editData,

  //         Amount: amount,

  //         // 🔥 WITHOUT GST
  //         ExtensionPrice: amount,

  //         Discount: discountAmount,
  //         DiscountAmount: discountAmount,

  //         NetAmount: netAmount,

  //         CGST: cgst,
  //         SGST: sgst,
  //         IGST: igst,

  //         SalesTax: salesTax,

  //         // 🔥 WITH GST
  //         LineTotal: lineTotal,

  //         UnitPrice: _.round(unitPrice, 2)
  //       };

  //       await this.calculateOrderTotal();
  //     }
  //   }
  // }

  async onProductEdit(event: any) {

    let editData = event;

    // ==========================================
    // VALIDATION
    // ==========================================

    for (const product of this.products) {

      const costCalculationType = 'Qty';

      if (
        costCalculationType === 'Qty' &&
        Number(product.OrderQuantity) <= 0
      ) {

        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Value',
          detail: 'OrderQuantity must be greater than 0.'
        });

        return;
      }
    }

    // ==========================================
    // BASIC VALUES
    // ==========================================

    const qty =
      _.toNumber(editData.OrderQuantity) || 0;

    const shippedWeight =
      _.toNumber(editData.ShipedWeight) || 0;

    const unitPrice =
      _.toNumber(editData.UnitPrice) || 0;

    const gstRate =
      _.toNumber(editData.GSTRate) || 0;

    // 🔥 DISCOUNT IS DIRECT AMOUNT
    const discountAmount =
      _.toNumber(editData.Discount) || 0;

    const costCalculationType = 'Qty';

    // ==========================================
    // AMOUNT = QTY × PRICE
    // GST SHOULD NOT BE INCLUDED
    // ==========================================

    let amount = 0;

    if (costCalculationType === 'Qty') {

      amount = _.round(
        qty * unitPrice,
        2
      );

    } else {

      amount = _.round(
        shippedWeight * unitPrice,
        2
      );
    }

    // ==========================================
    // VALIDATE DISCOUNT
    // ==========================================

    if (discountAmount > amount) {

      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Discount',
        detail: 'Discount cannot exceed Amount.'
      });

      return;
    }

    // ==========================================
    // NET AMOUNT
    // ==========================================

    const netAmount = _.round(
      amount - discountAmount,
      2
    );

    // ==========================================
    // TAXABLE CHECK
    // ==========================================

    const isTaxable =
      (typeof editData.IsTaxable === 'boolean' &&
        editData.IsTaxable === true) ||

      (typeof editData.IsTaxable === 'string' &&
        editData.IsTaxable === 'Y');

    // ==========================================
    // GST CALCULATION
    // ==========================================

    let salesTax = 0;
    let cgst = 0;
    let sgst = 0;
    let igst = 0;

    const form = this.createOrderForm.value;

    const supplyType = form.supplyType;

    const isExportSupply =
      supplyType === 'EXPORT' ||
      supplyType === 'SEZ';

    // EXPORT => ALWAYS IGST
    const isIGST =
      isExportSupply || this.isIGSTApplicable();

    const isLUT =
      form.isLUT === true &&
      (
        supplyType === 'EXPORT' ||
        supplyType === 'SEZ'
      );

    const isRCM =
      form.isRCM === true;

    // ==========================================
    // GST ONLY WHEN:
    // 1. TAXABLE
    // 2. GST RATE > 0
    // 3. NOT LUT
    // 4. NOT RCM
    // ==========================================

    if (
      isTaxable &&
      gstRate > 0 &&
      !isLUT &&
      !isRCM
    ) {

      salesTax = _.round(
        (netAmount * gstRate) / 100,
        2
      );

      if (isIGST) {

        igst = salesTax;

      } else {

        cgst = _.round(salesTax / 2, 2);
        sgst = _.round(salesTax / 2, 2);
      }
    }

    // ==========================================
    // FINAL LINE TOTAL
    // ==========================================

    const lineTotal = _.round(
      netAmount + salesTax,
      2
    );

    // ==========================================
    // UPDATE PRODUCT
    // ==========================================

    editData.UnitPrice = _.round(unitPrice, 2);

    // 🔥 Qty × Price only
    editData.Amount = amount;

    // 🔥 WITHOUT GST
    editData.ExtensionPrice = amount;

    editData.Discount = discountAmount;
    editData.DiscountAmount = discountAmount;

    editData.NetAmount = netAmount;

    editData.CGST = cgst;
    editData.SGST = sgst;
    editData.IGST = igst;

    editData.SalesTax = salesTax;

    // 🔥 WITH GST
    editData.LineTotal = lineTotal;

    // ==========================================
    // UPDATE GRID
    // ==========================================

    if (!this.isEdit) {

      const index = this.products.findIndex(
        product =>
          product.SalesOrderLineItemId ===
          editData.SalesOrderLineItemId
      );

      if (index !== -1) {

        this.updateSalesOrderLineItems(
          editData,
          index
        );

      } else {

        console.error(
          'Product not found',
          editData
        );

        this.messageService.add({
          severity: 'error',
          summary: 'Warning',
          detail: 'Error while updating product'
        });
      }

    } else {

      const index = this.products.findIndex(
        product =>
          product.LineItemNumber ===
          editData.LineItemNumber
      );

      if (index !== -1) {

        this.products[index] = {

          ...editData,

          Amount: amount,

          // WITHOUT GST
          ExtensionPrice: amount,

          Discount: discountAmount,
          DiscountAmount: discountAmount,

          NetAmount: netAmount,

          CGST: cgst,
          SGST: sgst,
          IGST: igst,

          SalesTax: salesTax,

          // WITH GST
          LineTotal: lineTotal,

          UnitPrice: _.round(unitPrice, 2)
        };

        await this.calculateOrderTotal();
      }
    }
  }

  updateSalesOrderLineItems(data: Product, index: number) {
    // this.loader = true;
    this.salesService.updateSalesOrderLineItem(data).subscribe(
      async (response: any) => {
        //  console.log(response);
        // Update this.products only if the update is successfull
        if (index !== -1) {
          this.products[index] = {
            ...data,
            ExtensionPrice: data.ExtensionPrice,
            CGST: data.CGST,
            SGST: data.SGST,
            IGST: data.IGST,
            SalesTax: data.SalesTax,
            UnitPrice: data.UnitPrice,
          };
          const isValid = this.calculateOrderTotal();
          if (await isValid) {
            this.createSalesOrder('TEMP.INVOICE');
          }
        }
        this.loader = false;
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while updating product' });
        this.loader = false;
      }
    );
  }



  deleteProduct(reset: boolean = false) {

    this.confirmationService.confirm({
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      message: 'Do you want to delete?',
      accept: () => {

        let selectedProductIds: any[] = [];

        if (!this.isEdit) {
          if (reset) {
            selectedProductIds = this.products.map(product => product.SalesOrderLineItemId);
          } else {
            selectedProductIds = this.selectedProduct.map(product => product.SalesOrderLineItemId);
          }

          this.loader = true;
          this.salesService.deleteSalesOrderLineItem(selectedProductIds).subscribe({
            next: async (data: any) => {
              this.loader = false;
              if (data) {
                this.products = this.products.filter(
                  product => !selectedProductIds.includes(product.SalesOrderLineItemId)
                );
                this.allProductData = this.allProductData.filter(
                  product => !selectedProductIds.includes(product.SalesOrderLineItemId)
                );
                this.selectedProduct = [];

                const isValid = await this.calculateOrderTotal();
                if (isValid) {
                  this.createSalesOrder('TEMP.INVOICE');
                }
                if (reset) {
                  setTimeout(() => {
                    const OrderNo = this.createOrderForm.controls.OrderNo.value;
                    this.createOrderForm.reset();
                    this.createOrderForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
                    this.createOrderForm.controls.OrderNo.setValue(OrderNo);
                  }, 2000);
                }
              }
            },
            error: error => {
              console.log(error);
              this.loader = false;
              this.messageService.add({
                severity: 'error',
                summary: 'Warning',
                detail: 'Error while deleting product'
              });
            }
          });
        } else {
          const idsToDelete = this.selectedProduct
            .map(product => product.SalesOrderLineItemId)
            .filter(id => id && id.toString().trim() !== '');

          this.deleteProductIds.push(...idsToDelete);

          const lineItemNumbers = this.selectedProduct.map(product => product.LineItemNumber);
          this.products = this.products.filter(product => !lineItemNumbers.includes(product.LineItemNumber));
          this.selectedProduct = [];
          this.calculateOrderTotal();
        }
      },
      reject: () => {
      }
    });

  }

  movetoShipping() {
    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
      const productCodeAutoCompleteElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
      if (productCodeAutoCompleteElement) {
        productCodeAutoCompleteElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    this.UpdateSalesOrderLineItems();
  }

  UpdateSalesOrderLineItems() {

    for (var product of this.products) {
      product.OrderQuantity = product.OrderQuantity;

      this.loader = true;
      this.salesService.updateSalesOrderLineItem(product).subscribe(
        (data: any) => {
          if (data) {
            // console.log(data);
            this.loader = false;
          } else {
            this.loader = false;
          }
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
        }
      );
    }

    this.createSalesOrder('SHIPPING', true);

  }

  reOpen() {
    this.route.queryParams.subscribe(params => {
      try {
        this.loader = true;
        const salesOrderId = JSON.parse(params['Data']);
        this.salesOrderId = salesOrderId;
        this.salesService.getSalesOrderById(salesOrderId).subscribe({
          next: (data: any) => {
            if (data) {
              this.isEdit = true;

              const BillToCustomerAddress = data.billToCustomer?.address
                ? `${data.billToCustomer.address.state}, ${data.billToCustomer.address.country}, ${data.billToCustomer.address.zip}`
                : '';

              const ShipToCustomerAddress = data.shipToCustomer?.address
                ? `${data.shipToCustomer.address.state}, ${data.shipToCustomer.address.country}, ${data.shipToCustomer.address.zip}`
                : '';

              this.createOrderForm.patchValue({
                OrderNo: data.salesOrderNumber,
                BillToCustomerCode: data.billToCustomerCode,
                BillToCustomerId: data.billToCustomerId,
                BillToCustomer: data.billToCustomer?.customerName,
                ShipToCustomerCode: data.shipToCustomerCode,
                ShipToCustomerId: data.shipToCustomerId,
                ShipToCustomer: data.shipToCustomer?.customerName,
                SalespersonCode: data.salespersonCode,
                SalespersonId: data.salespersonId,
                salesperson: data.salesperson?.salespersonName,
                ShipmentDate: data.shipmentDate ? new Date(data.shipmentDate) : '',
                MotorVehicalNo: data.motorVehicleNo,
                deliveryNote: data.deliveryNote,
                warehouse: data.warehouse?.warehouseName,
                WareHouseId: data.warehouseId,
                TermsCode: data.termsCode,
                PaymentTermsId: data.paymentTermsId,
                DispatchDocNo: data.dispatchDocNo,
                BillOfLading: data.billOfLading,
                EwbNo: data.ewbNo,
                purchaseOrderNumber: data.purchaseOrderNumber,
                LRRRNo: data.lrrrNo,
                DispatchThrough: data.dispatchThrough,
                BillToCustomerAddress: BillToCustomerAddress,
                ShipToCustomerAddress: ShipToCustomerAddress,
                BillToCustomerState: data.billToCustomer?.address?.state,

                BillToCustomerStateCode:
                  data.billToCustomer?.address?.stateCode,

                ShipToCustomerStateCode:
                  data.shipToCustomer?.address?.stateCode,

                warehouseStateCode:
                  data.warehouse?.address?.stateCode,

                warehouseState: data.warehouse?.address?.state,
                orderDate: data.orderDate ? new Date(data.orderDate) : null,
                requestedDate: data.requestedDate ? new Date(data.requestedDate) : null,
                serviceCallCode: data.serviceCallCode,
                ReferenceNumber: data.referenceNumber,
                Destination: data.destination,
                TermsOfDelivery: data.termsOfDelivery,
                SalesOrderInvoiceDate: data.salesOrderInvoiceDate ? new Date(data.salesOrderInvoiceDate) : null,
                IsClosed: data.isClosed,
                CustomerPODate: data.customerPODate ? new Date(data.customerPODate) : null,
                GSTOnFreight: data.gstOnFreight,
                FreightTotal: data.freightTotal,
                RateOnFreight: data.rateOnFreight,
                DiscountAmount: data.discountAmount,
                FinalTaxableAmt: data.FinalTaxableAmt,
                supplyType: data.supplyType,
                isLUT: data.isLUT ?? false,
                expTyp: data.exportType ?? '',
                isRCM: data.isRCM ?? false,
                POS: data.pos ?? '',
                FinancialYearId: data.financialYearId,
                CreatedBy: data.createdBy ?? localStorage.getItem('username'),
                projectBoMId: data.projectBoMId ?? null,
                projectName: data.projectName || data.projectBoM?.projectBoMName || '',
                projectNo: data.projectNo || data.projectBoM?.projectBoMCode || '',
              }, { emitEvent: false });

              const orderDate = this.createOrderForm.get('orderDate')?.value;
              if (orderDate) {
                this.onTransactionDateChange(orderDate, "Order");
              }

              const requestedDate = this.createOrderForm.get('requestedDate')?.value;
              if (requestedDate) {
                this.onTransactionDateChange(requestedDate, "Requested");
              }

              this.subscribeFinancialYearChanges();

              this.updateRCMState(data.supplyType);


              setTimeout(() => {
                this.setPlaceOfSupply();
                this.setExportType();
                this.isIGST =
                  this.isIGSTApplicable();
                this.calculateOrderTotal();
              });

              this.deliveryDate = data.requestedDate;
              this.orderTotal = data.orderTotal;
              this.weightTotal = data.totalWeight;
              this.SalesTaxTotal = data.salesTaxTotal;
              this.CGSTtotal = data.cgstTotal;
              this.SGSTtotal = data.sgstTotal;
              this.IGSTtotal = data.igstTotal;
              this.customerEmail = data.billToCustomer?.email;

              this.getSalesOrderLineItems(data.salesOrderNumber);
              // if (data.billToCustomerId) {
              //   this.loadOutstandingAmount(data.billToCustomerId);
              // }
              // this.getShipto(data.shipToCustomerId);
            }
            this.loader = false;
            // if (data.isClosed) {
            //   this.createOrderForm.disable();
            // }
            if (data.status === 'Open') {
              this.isOpenStatus = data.status === 'Open';
            }
            this.invoiceStatus = data.status || data.salesOrderStatus || '';
            this.priorPaidAmount = Number(data.totalPaid || data.priorPaidAmount || 0);
            this.isGlPosted = !!(data.isGlPosted ?? data.IsGlPosted);
            if (data.isClosed === true || this.isGlPosted) {
              this.loadGlEntries();
            }
          },
          error: error => {
            console.error(error);
            this.loader = false;
          }
        });
      } catch (error) {
        console.error('Error parsing query param:', error);
        this.loader = false;
      }
    });
  }

  getShipto(data: number) {
    this.loader = true;
    this.customerService.getCustomerById(data).subscribe({
      next: (data: any) => {
        const ShipTo = data;
        this.createOrderForm.controls.ShipToCustomer.setValue(ShipTo.customerName);
        const address = `${ShipTo.address.city, ShipTo.address.state}, ${ShipTo.address.country}, ${ShipTo.address.zip}`;
        this.createOrderForm.controls.ShipToCustomerAddress.setValue(address);
        this.loader = false;

      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    })
  }

  getSalesOrderLineItems(salesOrderNumber: number) {
    this.loader = true;
    this.salesService.getSalesOrderLineItem(salesOrderNumber).subscribe(
      (data: any) => {
        this.products = this.loadProducts(data);
        this.allProductData = [...this.products];
        // console.log(data);
        this.calculateOrderTotal();
        this.loader = false;
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
      }
    );
  }

  loadProducts(data: any): Product[] {
    return data.map((item: any) => {
      return this.loadProduct(item);
    });
  }

  loadProduct(data: any): Product {
    const qty =
      data.shipedQuantity === null || data.shipedQuantity === 0
        ? data.orderQuantity || 0
        : data.shipedQuantity;
    const price = data.unitPrice || 0;
    const product: Product = {
      SalesOrderLineItemId: data.salesOrderLineItemId || 0,
      purchaseOrderLineItemId: data.purchaseOrderLineItemId || 0,
      POReceiptLineItemId: data.poReceiptLineItemId || 0,
      PurchaseOrderNumber: data.purchaseOrderNumber || 0,
      SalesOrderNumber: data.salesOrderNumber || "",
      ProductId: data.productId || 0,
      ProductImage: data.productImage || null,
      QuotedQuantity: data.quotedQuantity || 0,
      LineItemNumber: data.lineItemNumber || 0,
      OrderQuantity: qty,
      Quantity: data.quantity || 0,
      POQuantity: data.poQuantity || 0,
      ReceivedQuantity: data.receivedQuantity || 0,
      CancelQuantity: data.cancelQuantity || 0,
      OpenQuantity: data.openQuantity || 0,
      AcceptedQuantity: data.acceptedQuantity || 0,
      RejectedQuantity: data.rejectedQuantity || 0,
      ShipedQuantity: data.shipedQuantity || 0,
      BackOrderQuantity: data.backOrderQuantity || 0,
      ExtendedCost: data.extendedCost || 0,
      Cost: data.cost || 0,
      Uom: data.uom || "",
      projectBoMId: data.projectBoMId || 0,
      projectBoMName: data.projectBoMName || "",
      PurchasingUom: data.purchasingUom || "",
      UnitPrice: price,
      HSNCode: data.hsnCode || 0,
      GSTRate: data.gstRate || 0,
      CGST: data.cgst || 0,
      SGST: data.sgst || 0,
      IGST: data.igst || 0,
      DepartmentId: data.departmentId || 0,
      POReceiptHeaderId: data.poReceiptHeaderId || 0,
      POReceiptNumber: data.poReceiptNumber || "",
      IsTaxable: data.isTaxable ?? true,
      StandardCost: data.standardCost || 0,
      ExtensionPrice: data.extensionPrice || (qty * price),
      AverageCost: data.averageCost || 0,
      AlternateCost: data.alternateCost || 0,
      SalesTax:
        (data.cgst || 0) +
        (data.sgst || 0) +
        (data.igst || 0),
      SerialId: data.serialId || data.lineItemNumber || 1,
      Weight: data.weight || 0,
      ShipedWeight: data.shipedWeight || 0,
      Labour: data.labour || 0,
      LineItemStatus: data.lineItemStatus || "",
      WareHouseId: data.wareHouseId || 0,

      ProductCode: data.productCode || "",
      ProductDescription: data.productDescription || "",
      Comment: data.comment || "",
      createdDate: data.createdDate ? new Date(data.createdDate) : new Date(),
      deliveryDate: data.deliveryDate ? new Date(data.deliveryDate) : undefined,
      BackOrderOrderNumber: data.backOrderOrderNumber || "",
      SpecialOrderPONumber: data.specialOrderPONumber || "",
      LocationId: data.locationId || 1,
      Profit: data.profit || 0,
      VendnorId: data.vendnorId || data.vendorId || 0,
      IsSpecialOrder: data.isSpecialOrder || false,
      SpecialCost: data.specialCost || 0,
      Discount: data.discount || 0,
      MarkupCost: data.markupCost || 0,
      MarginPercent: data.marginPercent || 0,
      IsActive: data.isActive ?? true,
      CreatedBy: data.createdBy || "",
      UpdatedBy: data.updatedBy || "",
      CostCalculation: data.costCalculation || "",
      SellingUom: data.sellingUom || "",
      ProductSize: data.productSize || "",
      ProductSpecification: data.productSpecification || "",
      VendorId: data.vendorId || 0,
      VendorName: data.vendorName || "",
      DateRequired: data.dateRequired || null,
      IsServiceType: data.isServiceType === true || data.isServiceType === 1,
      RejectionReason: data.rejectionReason || ""
    };

    return product;
  }


  update(MoveToOrder: boolean = false) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    if (!this.validateFinancialYear()) {
      return;
    }


    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
      const productCodeAutoCompleteElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
      if (productCodeAutoCompleteElement) {
        productCodeAutoCompleteElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    this.loader = true;

    this.salesService.deleteSalesOrderLineItem(this.deleteProductIds).subscribe({
      next: (data: any) => {
        if (data) {
          this.products = this.products.filter(
            p => !this.deleteProductIds.includes(p.SalesOrderLineItemId)
          );

          const requests = this.products.map(product => {
            if (product.BackOrderOrderNumber == null || product.BackOrderOrderNumber === "") {
              product.BackOrderOrderNumber = '0';
            } else {
              product.BackOrderOrderNumber = product.BackOrderOrderNumber.toString();
            }
            if (product.SpecialOrderPONumber == null || product.SpecialOrderPONumber === "") {
              product.SpecialOrderPONumber = '0';
            } else {
              product.SpecialOrderPONumber = product.SpecialOrderPONumber.toString();
            }
            product.CreatedBy = this.createOrderForm.controls.CreatedBy.value || '';

            if (product.deliveryDate) {
              const correctedDate = new Date(product.deliveryDate);
              const currentTime = new Date();
              correctedDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
              product.deliveryDate = correctedDate;
            }

            if (product.SalesOrderLineItemId) {
              return this.salesService.updateSalesOrderLineItem(product);
            } else {
              return this.salesService.createSalesOrderLineItem(product);
            }
          });

          forkJoin(requests).subscribe({
            next: () => {
              if (MoveToOrder) {
                this.createSalesOrder('ORDER', true);
              } else {
                this.createSalesOrder('DRAFT.INVOICE');
              }
              this.loader = false;
            },
            error: error => {
              console.error(error);
              this.loader = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update line items.' });
            }
          });
        }
      },
      error: error => {
        console.log(error);
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete line items.' });
      }
    });
  }

  updateInventory(status: string = "DirectInvoice") {
    this.loader = true;

    const data = this.createOrderForm.value;

    for (let product of this.allProductData) {

      const productId = product.ProductId || this.productId;
      //Updating the product inventory

      const Inventory: UpdateInventory = <UpdateInventory>{
        productId: productId,
        warehouseId: _.toNumber(data.WareHouseId),
        productCode: product.ProductCode,
        status: status,
        transactionNo: _.toString(data.OrderNo),
        transactionType: "Invoice",
        quantity: product.ShipedQuantity,
        uom: product.Uom,
        createdBy: localStorage.getItem('username'),
        transactionDate: new Date(),
        createdDate: new Date(),
      }

      // console.log(Inventory);
      this.inventoryService.updateInventoryNew(Inventory).subscribe({
        next: (data: any) => {
          // console.log(data);
          this.loader = false;
        },
        error: error => {
          console.log(error);
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while Inventory Update.' });
          this.loader = false;
          return;
        }
      });

    }
  }
  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault(); // Prevent form submission on Enter key press

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }
  onKeydown(event: KeyboardEvent, product: any) {
    if (event.key === 'Enter' || event.key === 'Tab') {
      event.preventDefault();
      this.onProductEdit(product);
      if (event.key === 'Tab') {
        this.moveFocusToNextField(event, product);
      }
    }
  }

  moveFocusToNextField(event: KeyboardEvent, product: any) {
    const inputs = document.querySelectorAll('input');
    const currentIndex = Array.from(inputs).indexOf(event.target as HTMLInputElement);
    const nextInput = inputs[currentIndex + 1] as HTMLInputElement;

    if (nextInput) {
      nextInput.focus();
    }
  }

  viewProducts(data?: any) {
    const productData = data || this.selectedProduct[0];
    const normalizedData = this.normalizeProductIdInPlace(productData);
    const productDataJson = JSON.stringify(normalizedData);
    this.productId = normalizedData.productId;
    this.dialogService.open(viewproductdataLookupComponent, {
      header: 'Product Details',
      width: '70%',
      data: {
        productData: this.isEdit ? productDataJson : undefined,
        productId: !this.isEdit ? this.productId : undefined
      }
    });
    // if (this.isEdit) {
    //   this.router.navigate([], {
    //     queryParams: { productData: productDataJson },
    //     queryParamsHandling: 'merge',
    //     skipLocationChange: true
    //   });
    // }
  }
  viewProduct(data?: any) {
    const productData = data || this.selectedProduct[0];
    const normalizedData = this.normalizeProductIdInPlace(productData);
    const productDataJson = JSON.stringify(normalizedData);
    this.productId = normalizedData.productId;

    const ref = this.dialogService.open(viewproductLookupComponent, {
      header: 'Product Details',
      width: '70%',
      data: {
        productData: productDataJson,
        productId: this.productId
      }
    });

    let messageShown = false;

    ref.onClose.subscribe(updatedProduct => {
      if (updatedProduct && !messageShown) {
        this.updateProductInGrid(productData, updatedProduct);

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Product updated successfully.`
        });
        messageShown = true;
      }
    });
  }
  updateProductInGrid(originalProduct: any, updatedProduct: any) {
    originalProduct.ProductCode = updatedProduct.ProductCode;
    originalProduct.ProductDescription = updatedProduct.ProductName;
    originalProduct.Uom = updatedProduct.UnitsOfMeasure || updatedProduct.UOM;
    originalProduct.HSNCode = updatedProduct.HSNCode;
    originalProduct.GSTRate = +updatedProduct.gstRate || 0;
    originalProduct.UnitPrice = updatedProduct.SalesPrice;
    originalProduct.ExtensionPrice = updatedProduct.
      SalesPrice * originalProduct.OrderQuantity;
    originalProduct.ProductSpecification = updatedProduct.ProductSpecification;

    const quantity = +originalProduct.OrderQuantity || 0;
    const unitPrice = +originalProduct.UnitPrice
      || 0;
    const gstRate = originalProduct.GSTRate;

    const baseAmount = quantity * unitPrice;

    // Correct SalesTax calculation
    const salesTax = +((baseAmount * gstRate) / 100).toFixed(2);

    originalProduct.SalesTax = salesTax;
    originalProduct.TaxableAmount = baseAmount;
    originalProduct.TotalWithTax = +(baseAmount + salesTax).toFixed(2);
    originalProduct.ExtendedCost = baseAmount;

    this.products = [...this.products];

    this.calculateOrderTotal();
  }
  private normalizeProductIdInPlace(product: any): any {
    if (product && product.ProductId) {
      product.productId = product.ProductId;
      delete product.ProductId;
    }
    return product;
  }
  async toggleEdit(product: Product, field: 'Weight' | 'OrderQuantity') {
    try {
      const productData = await this.getProductById(product.ProductId);
      const costCalculationType = productData.costCalculation || 'Qty';
      this.isEditingQuantity = false;
      this.isEditingWeight = false;
      if (costCalculationType === 'Qty' && field === 'OrderQuantity') {
        this.isEditingQuantity = true;
      } else if (costCalculationType === 'Wgt' && field === 'Weight') {
        this.isEditingWeight = true;
      }
      // else if (costCalculationType === 'Wgt' && field === 'OrderQuantity') {
      //   this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Cannot edit Quantity because the product type is Weight (Wgt).' });
      //   return;
      // } else if (costCalculationType === 'Qty' && field === 'Weight') {
      //   this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Cannot edit Weight because the product type is Quantity (Qty).' });
      //   return;
      // }
    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  }
  getFormControlName(): string {
    return this.productCostCalculationType === 'Qty' ? 'productQty' : 'productWgt';
  }

  getPlaceholder(): string {
    return this.productCostCalculationType === 'Qty' ? 'Qty' : 'Wgt';
  }


  createQuickProduct() {
    this.submitted = true;

    const isValid = this.validateCustomer();
    if (!isValid) {
      window.scroll(0, 0);
      return;
    }

    this.ref = this.dialogService.open(CloseQuickProductLookupComponent, {
      header: 'Create Quick Product',
      width: '70%',

    });
    this.ref.onClose.subscribe((data: Product) => {
      if (data) {
        const product = { value: data };
        this.setProduct(product);
      }
    });
  }


  // showProductDescription(productItem: any) {
  //   if (!productItem.ProductId && !productItem.productId) {
  //     this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Incomplete Product Data.' });
  //     return;
  //   }
  //   this.ref = this.dialogService.open(MultiProductDescriptionLookupComponent, {
  //     header: 'Product Code ' + productItem.ProductCode + ' - Descriptions',
  //     width: '60%',
  //     data: productItem
  //   });
  //   this.ref.onClose.subscribe((data: Product) => {
  //     if (data) {
  //       this.onProductEdit(data)
  //     }
  //   });
  // }

  showSpecification(productItem: any) {
    if (!productItem.ProductId && !productItem.productId) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Incomplete Product Data.' });
      return;
    }
    //productItem.Edit = this.isEdit;
    this.ref = this.dialogService.open(SpecificationLookupComponent, {
      header: 'Order Line Specification',
      width: '50%',
      data: productItem
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        productItem.ProductSpecification = data.ProductSpecification;
        this.onProductEdit(productItem);
      }
    });
  }

  showProductUom(productItem: Product) {
    this.ref = this.dialogService.open(UOMLookupComponent, {
      header: 'Unit of Measure',
      width: '60%',

    });
    this.ref.onClose.subscribe((selectedUOM: UnitsOfMeasure) => {
      if (selectedUOM) {
        productItem.Uom = selectedUOM.unitsofMeasure;
        this.onProductEdit(productItem);
      }
    });
  }


  openLinkedFiles() {
    if (this.ref) {
      this.ref.close();
    }
    const orderNo = this.createOrderForm.controls.OrderNo.value;
    this.ref = this.dialogService.open(ListLinkedFilesLookupComponent, {
      header: `Linked File For Order ${orderNo}`,
      width: '60%',
      data: { orderNo: orderNo }
    });
  }

  createQuickCustomer(status: boolean = true) {
    this.ref = this.dialogService.open(CloseQuickCustomerLookupComponent, {
      header: 'Create Quick Customer',
      width: '70%',

    });
    this.ref.onClose.subscribe((customerId: number) => {
      if (customerId) {
        this.getCustomerData(customerId, status);
      }
    });
  }

  getCustomerData(id: number, status: boolean) {
    this.customerService.getCustomerById(id).subscribe(
      (data: any) => {
        const customerData = {
          value: data
        }
        if (status) {
          this.setBillTo(customerData);
        } else {
          if (data.isShipToCustomer === true) {
            this.setShipTo(customerData);
          } else {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'It cannot be shipped to the customer.' });
          }
        }
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while fetching customer data.' });
      }
    );
  }

  showComment(productItem: Product) {
    // const productWithEdit = { ...productItem, Edit: this.isEdit };
    const productWithEdit = { ...productItem };
    this.ref = this.dialogService.open(POCommentsLookupComponent, {
      header: 'Order Line Remark',
      width: '50%',
      data: productWithEdit
    });
    this.ref.onClose.subscribe((data: string) => {
      if (data) {
        productItem.Comment = data;
        this.onProductEdit(productItem);
      }
    });
  }

  getInventoryStatus(productCode: string) {
    const warehouseId = this.createOrderForm.value.WareHouseId;
    if (!warehouseId) {
      return;
    }
    this.inventoryService.getInventoryStatus(productCode).subscribe({
      next: (data: any) => {
        if (data.success === false) {
        } else {
          const inventoryItem = data.find((item: { warehouseId: any; }) => item.warehouseId === warehouseId);
          if (inventoryItem) {
            this.QAvail = inventoryItem.quantityAvailable;
          } else {
            console.log(`No inventory item found for warehouse ID: ${warehouseId}`);
          }
        }
      },
      error: error => {
        console.log(error);
      }
    });
  }

  getSystemConfigData(): void {
    // this.loader = true;
    const appKey = 'inventory.qavail_warning';
    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (response: any) => {
        //this.loader = true;
        if (response.appKeycode == appKey) {
          if (response.data == 'Y') {
            this.isQAvailWarning = true;
          }
        }
      },
      error: error => {
        console.error('Error fetching System Config Data:', error);
        //this.loader = false;
      }
    });
  }

  createInvoice() {
    const shippedQty = this.products.reduce((sum, p) => sum + (Number(p.OrderQuantity) || 0), 0);
    const rawInvoiceDate = this.createOrderForm.value.SalesOrderInvoiceDate || new Date();
    const invoiceDateStr = getISTDateWithCurrentTime(rawInvoiceDate) ?? new Date().toISOString();

    const data = {
      SalesOrderNumber: this.createOrderForm.value.OrderNo,
      IsClosed: true,
      Status: 'Open',
      SalesOrderStatus: 'INVOICE',
      ShipedQuantity: shippedQty,
      UpdatedBy: localStorage.getItem('username'),
      SalesOrderInvoiceDate: invoiceDateStr,
    };

    this.confirmationService.confirm({
      header: 'Confirm Create Bill',
      message: 'Are you sure you want to create this Invoice ?',
      accept: () => {
        this.loader = true;
        this.prepareInvoiceLineItemsForSave();

        const lineItemUpdates = (this.products as Product[]).map(product =>
          this.salesService.updateSalesOrderLineItem(product)
        );

        const saveLineItems$ = lineItemUpdates.length > 0 ? forkJoin(lineItemUpdates) : of(null);

        (saveLineItems$ as Observable<any>).subscribe({
          next: () => {
            this.updateInventoryAndProductLedger('DirectInvoice');
            this.updateInvoiceBillStatus(data);
          },
          error: (error: any) => {
            console.error(error);
            this.loader = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to update invoice line items before posting.'
            });
          }
        });
      }
    });
  }
  UpdateSalesOrderLineItem() {
    this.prepareInvoiceLineItemsForSave();

    for (const product of this.products as Product[]) {
      this.loader = true;

      this.salesService.updateSalesOrderLineItem(product).subscribe({
        next: () => {
          this.loader = false;
        },
        error: (error: any) => {
          console.error(error);
          this.loader = false;
        }
      });
    }
  }

  private prepareInvoiceLineItemsForSave(): void {
    for (const product of this.products as Product[]) {
      const shippedQty = Number(product.OrderQuantity) || 0;
      const originalQty = Number(product.QuotedQuantity) || 0;
      const backOrderQty = originalQty > shippedQty ? originalQty - shippedQty : 0;

      product.ShipedQuantity = shippedQty;
      product.BackOrderQuantity = backOrderQty;
      product.LineItemStatus = backOrderQty > 0 ? 'BACKORDER' : 'INVOICE';
      product.UpdatedBy = localStorage.getItem('username') ?? '';
      product.BackOrderOrderNumber = '0';
      product.SpecialOrderPONumber = '0';
    }
  }

  updateInventoryAndProductLedger(status: string = "DirectInvoice") {
    this.loader = true;

    const data = this.createOrderForm.value;

    for (let product of this.allProductData) {

      const productId = product.ProductId || this.productId;

      const Inventory: UpdateInventory = <UpdateInventory>{
        productId: productId,
        warehouseId: _.toNumber(data.WareHouseId),
        productCode: product.ProductCode,
        status: status,
        transactionNo: _.toString(data.OrderNo),
        transactionType: "Invoice",
        quantity: Number(product.OrderQuantity ?? 0),
        uom: product.Uom,
        unitCost: 0,
        createdBy: localStorage.getItem('username'),
        transactionDate: new Date(),
        createdDate: new Date(),
      }

      this.inventoryService.UpdateInventoryAndProductLedger(Inventory).subscribe({
        next: () => this.loader = false,
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: 'Inventory update failed'
          });
          this.loader = false;
        }
      });
    }
  }

  updateInvoiceBillStatus(data: any) {
    data.Status = "Open";
    data.UpdatedBy = localStorage.getItem('username');
    data.updatedDate = getISTDateWithCurrentTime(data.updatedDate);

    this.loader = true;

    this.salesService.createSalesOrderWithARNew(data).subscribe({
      next: (res: any) => {
        if (!(res?.message?.includes('successfully') || res?.success === true)) {
          this.loader = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: res?.message || 'Unable to create Invoice Bill.'
          });
          return;
        }

        this.createOrderForm.controls.IsClosed.setValue(true);
        this.invoiceStatus = 'Open';

        const salesOrderId = Number(this.salesOrderId);
        const username = localStorage.getItem('username') || 'System';

        const finishNavigate = () => {
          if (this.sendEmailOnInvoice) {
            this.sendInvoiceEmail(() => this.navigateToInvoiceList());
          } else {
            this.navigateToInvoiceList();
          }
        };

        if (!salesOrderId) {
          this.loader = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Invoice created successfully!',
            life: 4000
          });
          finishNavigate();
          return;
        }

        this.salesService.glPostSalesInvoice(salesOrderId, { createdBy: username }).subscribe({
          next: (glRes: any) => {
            this.loader = false;
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Invoice created successfully!',
              life: 4000
            });
            this.handleSalesInvoiceGlPostResponse(glRes);
            finishNavigate();
          },
          error: (glErr: any) => {
            this.loader = false;
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Invoice created successfully!',
              life: 4000
            });
            this.messageService.add({
              severity: 'warn',
              summary: 'GL Pending',
              detail: glErr?.error?.message ?? glErr?.error?.Message ?? 'Invoice saved but GL posting did not complete.'
            });
            finishNavigate();
          }
        });
      },
      error: (err) => {
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error while creating Invoice Bill.'
        });
        console.error('Invoice Bill update error:', err);
      }
    });
  }

  loadGlEntries(): void {
    const id = Number(this.salesOrderId) || 0;
    if (!id) {
      return;
    }

    this.salesService.getGlEntriesForSalesInvoice(id).subscribe({
      next: (res: any) => {
        const entries = res?.entries ?? res?.Entries ?? [];
        if (!Array.isArray(entries)) {
          return;
        }

        this.glTransactionNo = (res.transactionNo ?? res.TransactionNo ?? '').toString();
        this.glEntries = this.mapGlEntriesForDisplay(entries);
        this.glTotalDebit = Number(res.totalDebit ?? res.TotalDebit ?? this.sumGlDebit(this.glEntries));
        this.glTotalCredit = Number(res.totalCredit ?? res.TotalCredit ?? this.sumGlCredit(this.glEntries));
        this.isGlPosted = this.isGlPosted || this.glEntries.length > 0;
      },
      error: () => {
        this.glEntries = [];
        this.glTotalDebit = 0;
        this.glTotalCredit = 0;
      }
    });
  }

  private mapGlEntriesForDisplay(entries: any[]): any[] {
    return (entries ?? []).map((e: any) => ({
      accountCode: e.accountCode ?? e.AccountCode ?? '',
      accountName: e.accountName ?? e.AccountName ?? '',
      debitAmount: Number(e.debitAmount ?? e.DebitAmount ?? 0),
      creditAmount: Number(e.creditAmount ?? e.CreditAmount ?? 0),
      warehouseName: e.warehouseName ?? e.WarehouseName ?? '',
      departmentName: e.departmentName ?? e.DepartmentName ?? '',
      postedDate: e.postedDate ?? e.PostedDate ?? null,
    }));
  }

  formatGlAmount(value: number | null | undefined): string {
    const num = Number(value ?? 0);
    return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  glFooterLabelColspan(): number {
    return 2;
  }

  glFooterTrailingColspan(): number {
    return this.glDisplayColumns.length - 4;
  }

  private sumGlDebit(rows: any[]): number {
    return rows.reduce((s, r) => s + Number(r.debitAmount || 0), 0);
  }

  private sumGlCredit(rows: any[]): number {
    return rows.reduce((s, r) => s + Number(r.creditAmount || 0), 0);
  }

  private handleSalesInvoiceGlPostResponse(res: any): void {
    const ok = res?.success !== false && res?.Success !== false;
    const msg = (res?.message ?? res?.Message ?? '').toString();
    const entryCount = Number(res?.entriesCreated ?? res?.EntriesCreated ?? 0);

    if (ok && entryCount > 0) {
      this.isGlPosted = true;
      this.loadGlEntries();
      this.messageService.add({
        severity: 'success',
        summary: 'GL Posted',
        detail: msg || `GL posted successfully (${entryCount} entries).`,
      });
      return;
    }
    if (ok && msg.toLowerCase().includes('already')) {
      this.isGlPosted = true;
      this.loadGlEntries();
      this.messageService.add({ severity: 'info', summary: 'GL', detail: msg });
      return;
    }
    if (ok && (msg.toLowerCase().includes('zero') || msg.toLowerCase().includes('skipped'))) {
      this.messageService.add({ severity: 'info', summary: 'GL', detail: msg });
      return;
    }
    if (!ok) {
      this.messageService.add({
        severity: 'warn',
        summary: 'GL Pending',
        detail: msg || 'Invoice saved but GL posting did not complete.',
      });
    }
  }

  openProductView(product: any) {
    if (!product?.SalesOrderNumber) {
      console.error('SalesOrderNumber is missing.');
      return;
    }

    this.loader = true;
    const salesOrderNo = product.SalesOrderNumber;

    this.salesService.getSalesOrderBySalesOrderNo(salesOrderNo).subscribe({
      next: (data: any) => {
        this.loader = false;

        if (data) {
          product.salesOrder = data;

          this.createOrderForm.patchValue({
            OrderNo: data.salesOrderNumber,
            IsClosed: data.isClosed
          });

          if (data.isClosed === true) {
            this.viewProducts(product);
          } else {
            this.viewProduct(product);
          }
        }
      },
      error: (error) => {
        console.error('Error fetching SalesOrder:', error);
        this.loader = false;
      }
    });
  }


  updateInventoryNew(status: string) {
    this.loader = true;
    const data = this.createOrderForm.value;
    const inventoryUpdates = this.allProductData.map(product => {
      const productId = product.ProductId || this.productId;
      return {
        productId: productId,
        warehouseId: _.toNumber(data.WareHouseId),
        productCode: product.ProductCode,
        status: status,
        transactionNo: _.toString(data.OrderNo),
        transactionType: "Invoice",
        quantity: product.OrderQuantity,
        createdBy: localStorage.getItem('username'),
        transactionDate: new Date(),
        createdDate: new Date(),
      };
    });

    from(inventoryUpdates)
      .pipe(concatMap(inv => this.inventoryService.updateInventoryNew(inv)))
      .subscribe({
        next: () => { },
        complete: () => {
          this.loader = false;

        },
        error: (err) => {
          this.loader = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: 'Error occurred while updating inventory.'
          });
          console.error(err);
        }
      });
  }


  // email functionality

  getSystemConfigDataForEmail(): void {
    //this.loader = true;
    const appKey = 'AUTO_INVOICE_EMAIL';
    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (response: any) => {
        //this.loader = false;
        if (response.data === 'Y') {
          this.sendEmailOnInvoice = true;
        }
      },
      error: error => {
        console.error('Error fetching System Config Data:', error);
        //this.loader = false;
      }
    });
  }

  getCompanyDetails() {
    this.administratorService.getCompanyDetails().subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          const company = data[0];
          this.companyInfo = {
            companyName: company.companyName,
            companyEmail: company.emailID1,
            companyPhone: company.mobile,
            companyWebsite: `https://${company.website?.replace(/^https?:\/\//, '')}`,
          };
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  sendInvoiceEmail(onComplete?: () => void) {

    if (!this.sendEmailOnInvoice) {
      onComplete?.();
      return;
    }

    const authString = localStorage.getItem('auth');
    if (!authString) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Auth information is missing' });
      onComplete?.();
      return;
    }

    const auth = JSON.parse(authString);
    if (!auth.tenant?.tenantCode) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Tenant Code is missing' });
      onComplete?.();
      return;
    }

    const tenant = auth.tenant.tenantCode;
    const formCode = 'Invoice';
    const templateCode = 'auto-invoice-creation-template';

    this.loader = true;

    this.getUserDepartmentName().subscribe(departmentName => {

      this.reportService.getReportName(formCode).pipe(

        switchMap((report: any) => {
          if (!report?.path) {
            throw new Error('REPORT_MISSING');
          }
          const reportPath = report.path;

          return this.salesService.getEmailTemplate(tenant, templateCode).pipe(
            map(templateResponse => ({ templateResponse, reportPath }))
          );
        }),

        map(({ templateResponse, reportPath }) => {

          const template =
            templateResponse?.body ??
            templateResponse?.Body ??
            templateResponse?.templateBody ??
            templateResponse?.TemplateBody ??
            templateResponse?.emailBody ??
            templateResponse?.EmailBody;

          if (!template) {
            throw new Error('TEMPLATE_MISSING');
          }

          const templateData = {
            customerName: this.createOrderForm.controls['BillToCustomer'].value || 'Customer',
            orderNumber: this.createOrderForm.controls['OrderNo'].value || '',
            invoiceNumber: this.createOrderForm.controls['OrderNo'].value || '',
            orderDate: formatDateDDMMYY(this.createOrderForm.controls['orderDate'].value),
            invoiceDate: formatDateDDMMYY(this.createOrderForm.controls['orderDate'].value),
            billToName: this.createOrderForm.controls['BillToCustomer'].value || 'Customer',
            shipToName: this.createOrderForm.controls['ShipToCustomer'].value || 'Customer',
            salespersonName: this.createOrderForm.controls['salesperson'].value || 'Not assigned',
            salespersonCode: this.createOrderForm.controls['SalespersonCode'].value || '',
            warehouseName: this.createOrderForm.controls['warehouse'].value || '',
            orderTotal: this.orderTotal.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }),
            totalAmount: this.orderTotal.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }),
            cgstTotal: this.CGSTtotal.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }),
            sgstTotal: this.SGSTtotal.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }),
            igstTotal: this.IGSTtotal.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }),
            salesTaxTotal: (this.CGSTtotal + this.SGSTtotal + this.IGSTtotal).toLocaleString('en-IN', { style: 'currency', currency: 'INR' }),
            currentYear: new Date().getFullYear(),
            companyName: this.companyInfo?.companyName || ' ',
            companyEmail: this.companyInfo?.companyEmail || ' ',
            companyPhone: this.companyInfo?.companyPhone || ' ',
            companyWebsite: this.companyInfo?.companyWebsite || ' ',
          };

          return {
            emailBody: this.emailTemplateService.replacePlaceholders(template, templateData),
            reportPath
          };
        }),

        switchMap(({ emailBody, reportPath }) => {

          const emailToId = this.customerEmail || this.selectedCustomerEmail;

          if (!emailToId) {
            throw new Error('EMAIL_MISSING');
          }

          const emailData = {
            EmailToId: emailToId,
            EmailToName: this.createOrderForm.controls['BillToCustomer'].value || 'Customer',
            EmailSubject: `Invoice ${this.createOrderForm.controls['OrderNo'].value} from ${this.companyInfo?.companyName || 'our company'}`,
            EmailBody: emailBody,
            OrderNumber: this.createOrderForm.controls['OrderNo'].value,
            OrderType: 'Invoice',
            TenantId: tenant,
            ReportPath: reportPath,
            DepartmentName: departmentName
          };

          return this.salesService.SendMail(emailData);
        }),

        catchError(err => {
          this.loader = false;

          let message = 'Email failed to send.';
          if (err.message === 'REPORT_MISSING') {
            message = 'Invoice report not available. Email sending aborted.';
          } else if (err.message === 'TEMPLATE_MISSING') {
            message = 'Email template not found.';
          } else if (err.message === 'EMAIL_MISSING') {
            message = 'Customer email is missing.';
          }

          this.messageService.add({ severity: 'error', summary: 'Failed', detail: message });

          onComplete?.();
          return EMPTY;
        })

      ).subscribe({
        next: () => {
          this.loader = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Email Sent',
            detail: 'Invoice email sent successfully.'
          });
          this.createRecentInteractions(onComplete, departmentName);
        },
        error: (err: any) => {
          this.loader = false;
          console.error('Unexpected invoice email error:', err);
          onComplete?.();
        }
      });
    });
  }

  createRecentInteractions(onComplete?: () => void, departmentName: string = '') {
    const formData = this.createOrderForm.value;
    const nowUTC = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(nowUTC.getTime() + istOffset);

    const appKey = departmentName ? `dept.email.${departmentName}` : 'emailid';

    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (config: any) => {
        const fromEmail = config?.data || 'default@example.com';

        const recentInteraction: RecentInteractions = {
          sendDate: istDate,
          type: "Send Mail",
          from: fromEmail,
          to: this.customerEmail || this.selectedCustomerEmail || 'default@example.com',
          subject: `Invoice ${formData.OrderNo} - created successfully`,
          customerNumber: formData.BillToCustomerCode ?? '',
          refId: this.salesOrderId ?? 0,
          description: `Invoice ${this.isEdit ? 'updated' : 'created'} successfully`,
          createdBy: localStorage.getItem('username') || '',
          isActive: true
        };

        this.salesService.createRecentInteractions(recentInteraction).subscribe({
          next: (response) => {
            this.loader = true;
            console.log('Recent interaction created successfully:', response);
            onComplete?.();
          },
          error: (err) => {
            this.loader = false;
            console.error('Error creating recent interaction:', err);
            onComplete?.();
          }
        });
      },
      error: err => console.error('Recent interaction error:', err)
    });
  }

  gstOptions = [
    { label: 'GST0 - (0%)', value: 0 },
    { label: 'GST5 - (5%)', value: 5 },
    { label: 'GST12 - (12%)', value: 12 },
    { label: 'GST18 - (18%)', value: 18 },
    { label: 'GST28 - (28%)', value: 28 }
  ];
  calculateFreightGST() {

    const freight = Number(this.createOrderForm.get('FreightTotal')?.value) || 0;
    const rate = Number(this.createOrderForm.get('RateOnFreight')?.value) || 0;

    const gstAmount = (freight * rate) / 100;

    this.createOrderForm.patchValue({
      GSTOnFreight: Number(gstAmount.toFixed(2))
    }, { emitEvent: false });
    this.calculateOrderTotal();
  }

  getUserDepartmentName(): Observable<string> {
    const authString = localStorage.getItem('auth');
    if (!authString) return of('');

    const auth = JSON.parse(authString);
    const user = auth?.user;

    if (!user?.id) return of('');

    return this.administratorService.getUserById(user.id).pipe(
      switchMap((userData: any) => {
        const departmentId =
          userData?.departmentId;

        if (!departmentId) return of('');

        return this.porderservice.getDepartmentById(departmentId);
      }),
      map((departmentData: any) => {
        return departmentData?.departmentName;
      }),
      catchError(err => {
        console.error('Error fetching department name:', err);
        return of('');
      })
    );
  }

  supplyTypes = [
    { code: 'B2B', description: 'Business to Business' },
    { code: 'SEZWP', description: 'SEZ with payment' },
    { code: 'SEZWOP', description: 'SEZ without payment' },
    { code: 'EXPWP', description: 'Export with Payment' },
    { code: 'EXPWOP', description: 'Export without Payment' },
    { code: 'DEXP', description: 'Deemed Export' }
  ];



  getSupplyType(customer: any): string {


    //const code = customer.gstTreatmentCode || customer.gstTreatment; // fallback
    const code = customer.GSTTreatmentCode || customer.gstTreatmentCode || customer.gstTreatment;

    // const isSEZ = customer.isSEZ == 1 || customer.isSEZ === true;
    // const isOverseas = customer.isOverseas == 1 || customer.isOverseas === true;

    const isSEZ = code === 'SEZ';
    const isOverseas = code === 'OVR';

    // console.log('Customer:', customer);
    // console.log('Code:', code);
    // console.log('isSEZ:', isSEZ);
    // console.log('isOverseas:', isOverseas);

    // ✅ EXPORT (highest priority)
    if (isOverseas || customer.address?.country !== 'India') {
      return 'EXPORT';
    }

    // ✅ SEZ
    if (isSEZ || code === 'SEZ') {
      return 'SEZ';
    }

    // ✅ DEEMED EXPORT
    if (code === 'DEX') {
      return 'DEEMED EXPORT';
    }

    // ✅ B2B
    if (code === 'REG') {
      return 'B2B';
    }

    // ✅ COMPOSITION
    if (code === 'CMP') {
      return 'B2B-COMPOSITION';
    }

    // ✅ Default
    return 'B2C';
  }
  // isIGSTApplicable(): boolean {

  //   const form = this.createOrderForm.value;

  //   const supplyType = form.supplyType;
  //   const fromStateCode = form.warehouseState;
  //   const toStateCode =
  //     form.supplyType === 'B2B'
  //       ? form.BillToCustomerStateCode
  //       : form.ShipToCustomerStateCode || form.BillToCustomerStateCode;

  //   if (!supplyType || !fromStateCode || !toStateCode) return false;

  //   switch (supplyType) {

  //     case 'EXPORT':
  //     case 'SEZ':
  //     case 'DEEMED EXPORT':
  //       return true;

  //     case 'B2B':
  //     case 'B2B-COMPOSITION':
  //     case 'B2C':
  //       return fromStateCode !== toStateCode;

  //     default:
  //       return false;
  //   }
  // }

  // isIGSTApplicable(): boolean {

  //   const form = this.createOrderForm.value;

  //   const supplyType = form.supplyType;

  //   // MUST USE STATE CODE
  //   const fromStateCode =
  //     String(form.warehouseStateCode || '').trim();

  //   const toStateCode =
  //     String(
  //       form.POS ||
  //       form.ShipToCustomerStateCode ||
  //       form.BillToCustomerStateCode ||
  //       ''
  //     ).trim();

  //   if (!fromStateCode || !toStateCode) {
  //     return false;
  //   }

  //   switch (supplyType) {

  //     case 'EXPORT':
  //     case 'DEEMED EXPORT':
  //       return true;

  //     case 'SEZ':
  //     case 'B2B':
  //     case 'B2B-COMPOSITION':
  //     case 'B2C':
  //       return fromStateCode !== toStateCode;

  //     default:
  //       return false;
  //   }
  // }

  isIGSTApplicable(): boolean {

    const form = this.createOrderForm.value;

    const supplyType =
      String(form.supplyType || '').trim();

    // Warehouse State Code
    const fromStateCode =
      String(form.warehouseStateCode || '').trim();

    // Customer State Code
    let toStateCode = '';

    switch (supplyType) {

      case 'EXPORT':
      case 'DEEMED EXPORT':
        return true;

      case 'SEZ':

        // SEZ always IGST
        return true;

      case 'B2B':
      case 'B2B-COMPOSITION':

        toStateCode =
          String(
            form.BillToCustomerStateCode || ''
          ).trim();

        break;

      case 'B2C':

        toStateCode =
          String(
            form.ShipToCustomerStateCode ||
            form.BillToCustomerStateCode ||
            ''
          ).trim();

        break;

      default:
        return false;
    }

    if (!fromStateCode || !toStateCode) {
      return false;
    }

    // Interstate check
    return fromStateCode !== toStateCode;
  }

  getLUTLabel(): string {
    const type = this.createOrderForm.value.supplyType ?? '';

    const map: Record<string, string> = {
      EXPORT: 'Export under LUT (No GST)',
      SEZ: 'Supply to SEZ under LUT (No GST)'
    };

    return map[type] || 'Supply under LUT';
  }

  getExportType(): string {

    const form = this.createOrderForm.value;

    const type = form.supplyType;
    const isLUT = form.isLUT;

    if (type === 'EXPORT') {
      return isLUT ? 'EXPWOP' : 'EXPWP';
    }

    if (type === 'SEZ') {
      return isLUT ? 'SEZWOP' : 'SEZWP';
    }

    return '';
  }


  setExportType() {

    const form = this.createOrderForm.value;

    const type = form.supplyType;
    const isLUT = form.isLUT;

    let expTyp = '';

    if (type === 'EXPORT') {
      expTyp = isLUT ? 'EXPWOP' : 'EXPWP';
    } else if (type === 'SEZ') {
      expTyp = isLUT ? 'SEZWOP' : 'SEZWP';
    } else {
      expTyp = ''; // 🔥 CLEAR for non export types
    }

    this.createOrderForm.patchValue({
      expTyp: expTyp
    }, { emitEvent: false }); // 🔥 avoid loop
  }


  private exportTypeMap: Record<string, string> = {
    EXPWOP: 'Export without payment (LUT)',
    EXPWP: 'Export with payment',
    SEZWOP: 'SEZ without payment (LUT)',
    SEZWP: 'SEZ with payment'
  };
  getExportTypeLabel(): string {

    const type = this.createOrderForm.get('expTyp')?.value ?? '';

    return this.exportTypeMap[type] || '';
  }



  isExportOrSEZ(): boolean {
    const type = this.createOrderForm.value.supplyType;
    return type === 'EXPORT' || type === 'SEZ';
  }
  validateRCM() {
    const form = this.createOrderForm.value;

    if (form.isRCM && (form.supplyType === 'EXPORT' || form.supplyType === 'SEZ' || form.supplyType === 'B2C')) {

      this.messageService.add({
        severity: 'warn',
        summary: 'Invalid RCM',
        detail: 'RCM not applicable for this supply type'
      });

      this.createOrderForm.patchValue({ isRCM: false });
    }
  }

  isRCMDisabled(): boolean {
    const type = this.createOrderForm.get('supplyType')?.value;

    return type != null && ['EXPORT', 'SEZ', 'B2C'].includes(type);
  }

  setPlaceOfSupply() {

    const form = this.createOrderForm.value;

    // ✅ EXPORT
    if (form.supplyType === 'EXPORT') {
      this.createOrderForm.patchValue({
        POSDisplay: 'Other Country',
        POS: '96'
      }, { emitEvent: false });
      return;
    }

    // ✅ B2B → ALWAYS BillTo (GST RULE)
    if (form.supplyType === 'B2B') {
      this.createOrderForm.patchValue({
        POSDisplay: form.BillToCustomerState || '',
        POS: form.BillToCustomerStateCode || ''
      }, { emitEvent: false });
      return;
    }

    // ✅ Others → ShipTo priority
    const posName = form.ShipToCustomerState || form.BillToCustomerState || '';
    const posCode = form.ShipToCustomerStateCode || form.BillToCustomerStateCode || '';

    this.createOrderForm.patchValue({
      POSDisplay: posName,
      POS: posCode
    }, { emitEvent: false });

    // console.log("BillToStateCode:", form.BillToCustomerStateCode);
    // console.log("ShipToStateCode:", form.ShipToCustomerStateCode);
  }



  updateRCMState(supplyType: string) {

    const NON_RCM_TYPES = ['EXPORT', 'SEZ', 'B2C'];

    this.showRCM = !NON_RCM_TYPES.includes(supplyType);

    const rcm = this.createOrderForm.get('isRCM');

    if (!this.showRCM) {
      rcm?.setValue(false, { emitEvent: false });
      rcm?.disable({ emitEvent: false });
    } else {
      rcm?.enable({ emitEvent: false });
    }
  }

  get canShow(): boolean {
    const status = this.invoiceStatus;

    return this.isEdit === true
      && !['Paid', 'Draft', 'Void'].includes(status);
  }

  get showGlPostingTab(): boolean {
    return this.isGlPosted
      || this.glEntries.length > 0
      || !!this.createOrderForm.get('IsClosed')?.value;
  }

  openApplyCreditsDialog() {

    // Financial Year validation
    if (!this.validateApplyCreditsFinancialYear()) {
      return;
    }

    const customerId = this.createOrderForm.get('BillToCustomerId')?.value;
    const invoiceNo = this.createOrderForm.get('OrderNo')?.value;
    const totalInvoiceAmount = this.orderTotal || 0;
    const priorPaidAmount = this.priorPaidAmount || 0;

    if (!customerId) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select a customer first',
        life: 3000
      });
      return;
    }

    if (!invoiceNo) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please save the invoice first before applying credits',
        life: 3000
      });
      return;
    }

    this.loader = true;

    if (!this.salesOrderId) {
      this.loader = false;
      const ref = this.dialogService.open(ApplyCustomerCreditsLookupComponent, {
        header: 'Apply Customer Credits',
        width: '80%',
        data: {
          customerId,
          invoiceNo,
          billAmount: totalInvoiceAmount,
          totalBillAmount: totalInvoiceAmount,
          priorPaidAmount
        }
      });

      ref.onClose.subscribe((result: any) => {
        if (result && result.appliedCredits && result.appliedCredits.length > 0) {
          this.saveAppliedCredits(result);
        }
      });
      return;
    }

    this.salesService.getSalesOrderById(this.salesOrderId).subscribe({
      next: (data: any) => {
        this.loader = false;

        const appliedPriorPaidAmount = Number(data.totalPaid || data.priorPaidAmount || priorPaidAmount);
        const actualAmountDue = Math.max(0, Number(data.orderTotal || totalInvoiceAmount) - appliedPriorPaidAmount);

        const ref = this.dialogService.open(ApplyCustomerCreditsLookupComponent, {
          header: 'Apply Customer Credits',
          width: '80%',
          data: {
            customerId,
            invoiceNo,
            billAmount: actualAmountDue,
            totalBillAmount: Number(data.orderTotal || totalInvoiceAmount),
            priorPaidAmount: appliedPriorPaidAmount
          }
        });

        ref.onClose.subscribe((result: any) => {
          if (result && result.appliedCredits && result.appliedCredits.length > 0) {
            this.saveAppliedCredits(result);
          }
        });
      },
      error: () => {
        this.loader = false;

        const ref = this.dialogService.open(ApplyCustomerCreditsLookupComponent, {
          header: 'Apply Customer Credits',
          width: '80%',
          data: {
            customerId,
            invoiceNo,
            billAmount: Math.max(0, totalInvoiceAmount - priorPaidAmount),
            totalBillAmount: totalInvoiceAmount,
            priorPaidAmount
          }
        });

        ref.onClose.subscribe((result: any) => {
          if (result && result.appliedCredits && result.appliedCredits.length > 0) {
            this.saveAppliedCredits(result);
          }
        });
      }
    });
  }

  saveAppliedCredits(result: any) {
    this.loader = true;
    const payload = {
      invoiceNo: result.invoiceNo,
      customerId: result.customerId,
      appliedCredits: result.appliedCredits,
      totalCreditsApplied: result.totalCreditsApplied,
      totalTdsApplied: result.totalTdsApplied,
      totalApplied: result.totalApplied,
      remainingBalance: result.remainingBalance,
      billAmount: result.billAmount,
      appliedOn: result.appliedOn,
      createdBy: localStorage.getItem('username'),
      createdDate: getISTDateWithCurrentTime(result.appliedOn ?? new Date())
    };

    this.paymentService.applyCustomerCredits(payload).subscribe({
      next: (res: any) => {
        this.loader = false;
        if (res.success) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || `Successfully applied ₹${result.totalApplied.toFixed(2)} in customer credits`,
            life: 3000
          });

          if (this.salesOrderId) {
            this.salesService.getSalesOrderById(this.salesOrderId).subscribe({
              next: (data: any) => {
                this.invoiceStatus = data.status || data.salesOrderStatus || this.invoiceStatus;
                this.priorPaidAmount = Number(data.totalPaid || data.priorPaidAmount || this.priorPaidAmount);
                this.orderTotal = Number(data.orderTotal || this.orderTotal);

                if (this.invoiceStatus === 'Paid') {
                  this.messageService.add({
                    severity: 'info',
                    summary: 'Invoice Status',
                    detail: 'This invoice is now fully paid.',
                    life: 3000
                  });
                }
              },
              error: () => { }
            });
          } else {
            this.priorPaidAmount = Number(this.priorPaidAmount) + Number(result.totalApplied || 0);
          }
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: res.message || 'Failed to apply customer credits',
            life: 3000
          });
        }
      },
      error: () => {
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error while applying customer credits',
          life: 3000
        });
      }
    });
  }

  currentFinancialYear: any;

  loadCurrentFinancialYear() {
    this.salesService.getCurrentFinancialYear().subscribe({
      next: (response: any) => {
        //console.log(response.data.fyName);

        if (!response.data) {

          this.messageService.add({
            severity: 'error',
            summary: 'Financial Year',
            // detail: 'No open Financial Year found for current date.'
            detail: 'No Open Financial Year is available for the current date. Please contact your administrator.'
          });

          return;
        }

        this.currentFinancialYear = response.data;

        this.createOrderForm.patchValue({
          FinancialYearId: this.currentFinancialYear.fyId
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No open Financial Year found.'
        });
      }
    });
  }

  validateFinancialYear(): boolean {

    const orderDate = this.createOrderForm.controls.orderDate.value;
    const requestedDate = this.createOrderForm.controls.requestedDate.value;

    if (!orderDate) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Order Date is required.'
      });
      return false;
    }

    if (!requestedDate) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Requested Date is required.'
      });
      return false;
    }

    const fy = this.currentFinancialYear;

    if (!fy) {
      this.messageService.add({
        severity: 'error',
        summary: 'Financial Year',
        detail: 'No active Financial Year found.'
      });
      return false;
    }

    // Locked FY
    if (fy.status === 'Locked') {
      this.messageService.add({
        severity: 'error',
        summary: 'Locked Financial Year',
        detail: `Financial Year ${fy.fyName} is Locked.`
      });
      return false;
    }

    // Closed FY
    if (fy.status === 'Closed') {
      this.messageService.add({
        severity: 'error',
        summary: 'Closed Financial Year',
        detail: `Financial Year ${fy.fyName} is Closed.`
      });
      return false;
    }

    const startDate = new Date(fy.startDate);
    const endDate = new Date(fy.endDate);

    const order = new Date(orderDate);
    const requested = new Date(requestedDate);

    // Order Date validation
    if (order < startDate || order > endDate) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Order Date',
        detail: `Please select an Order Date within the Financial Year (${this.formatDate(startDate)} to ${this.formatDate(endDate)}).`
      });
      return false;
    }

    // Requested Date validation
    if (requested < startDate || requested > endDate) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Requested Date',
        detail: `Please select a Requested Date within the Financial Year (${this.formatDate(startDate)} to ${this.formatDate(endDate)}).`
      });
      return false;
    }

    return true;
  }

  formatDate(date: Date): string {

    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });

  }

  onTransactionDateChange(date: Date, transaction: string) {
    // if (this.isInitializing) {
    //   return;
    // }
    if (!date) {
      this.currentFinancialYear = null;

      this.createOrderForm.patchValue({
        FinancialYearId: null
      });

      return;
    }

    this.salesService.getFinancialYearByDate(date).subscribe({
      next: (response: any) => {
        // console.log("Financial Year Response:", response);
        if (!response.success || !response.data) {

          this.currentFinancialYear = null;

          this.createOrderForm.patchValue({
            FinancialYearId: null
          });

          this.messageService.add({
            severity: 'error',
            summary: 'Financial Year',
            detail: `No Open Financial Year found for the selected ${transaction} date.`
          });

          return;
        }

        this.currentFinancialYear = response.data;

        this.createOrderForm.patchValue({
          FinancialYearId: response.data.fyId
        });
      },

      error: () => {

        this.currentFinancialYear = null;

        this.createOrderForm.patchValue({
          FinancialYearId: null
        });

        this.messageService.add({
          severity: 'error',
          summary: 'Financial Year',
          detail: 'Unable to fetch Financial Year.'
        });
      }
    });
  }

  getProjectLookup() {
    this.ref = this.dialogService.open(ProjectBomLookupComponent, {
      header: 'Project List',
      width: '80%',
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.createOrderForm.patchValue({
          projectBoMId: data.projectBoMId,
          projectName: data.projectBoMName,
          projectNo: data.projectBoMCode
        });
      }
    });
  }

  clearProject() {
    this.createOrderForm.patchValue({
      projectBoMId: null,
      projectName: '',
      projectNo: ''
    });
  }

  validateApplyCreditsFinancialYear(): boolean {

    const orderDate = this.createOrderForm.controls.orderDate.value;
    
    if (!orderDate) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Order Date is required.'
      });
      return false;
    }

    const fy = this.currentFinancialYear;

    if (!fy) {
      this.messageService.add({
        severity: 'error',
        summary: 'Financial Year',
        detail: 'No active Financial Year found. Apply Credits operation is not allowed.'
      });
      return false;
    }

    // Locked FY
    if (fy.status === 'Locked') {
      this.messageService.add({
        severity: 'error',
        summary: 'Locked Financial Year',
        detail: `Financial Year ${fy.fyName} is Locked. Apply Credits operation is not allowed.`
      });
      return false;
    }

    // Closed FY
    if (fy.status === 'Closed') {
      this.messageService.add({
        severity: 'error',
        summary: 'Closed Financial Year',
        detail: `Financial Year ${fy.fyName} is Closed. Apply Credits operation is not allowed.`
      });
      return false;
    }

    const startDate = new Date(fy.startDate);
    const endDate = new Date(fy.endDate);
    const invoiceDate = new Date(orderDate);

    if (invoiceDate < startDate || invoiceDate > endDate) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Financial Year',
        detail: `Apply Credits is not allowed because the Order Date (${this.formatDate(invoiceDate)}) is outside the Financial Year (${this.formatDate(startDate)} to ${this.formatDate(endDate)}).`
      });
      return false;
    }

    return true;
  }
}


